import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import React from "react";
import moment from "moment";
import { ISortingData } from "../../../components/src/OrderTable/src/TableCell";
import { makeApiMessage } from "../../../components/src/common";
import { IFilter } from "../../../components/src/FilterPopover";
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
import { getStorageData } from "../../../framework/src/Utilities";
import { IUserContext } from "../../navigationmenu/src/PageContainerController.web";
import { IMyUser,PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { InvoiceRawData } from "../../print/src/PrintController";
import {
  CartsItemsPreferencesData,
  CreatePreferencesData,
  EditSpecificationType,
  IAdjustCartProduct,
  IadjustSpecification,
  IpreferenceData,
  SelectedService,
  StoreManagementDetails,
  UniqueCombination,
  UpdateOrderBody,
  productTypes,
} from "./utils";
import {
  CatalogueList as CatalogueDataList,
  Service as ServiceData,
  IItemData,
  IlaundryOrder,
  CustomerSpecification,
  OrderItemPreferences
} from "../../../components/src/Interface";
import {
  PlantPermissionStatus,
  checkForPlantPermissonStatus,
  checkIsFilterApplied,
  conditionalString,
  customPermissionApiKey,
  debounce,
  getDateRangeForQuery,
  sortCondition,
  sortStringCondition
} from "../../../blocks/utilities/src/CustomBlockHelpers";

import { CustomEnums, getCustomEnumName } from "../../../blocks/utilities/src/CustomBlockHelpers";
import { isNumber, toString, isEqual } from "lodash"
import qzTray from "qz-tray";
import { IFormValues } from "../../../blocks/OrderCreation/src/OrderCreation2Controller.web";
import { SelectedPreferenceData } from "../../../blocks/ProductDescription/src/EditPreferenceController";
const DATA_SHARED_FILTER_OPTIONS = [
  {
    label: "Yes",
    value: "true"
  },
  {
    label: "No",
    value: "false"
  },
]

const CONVEYER_DATA_SHARED_FILTER_OPTIONS = [
  {
    label: "Yes",
    value: "sent"
  },
  {
    label: "No",
    value: "not_sent"
  },
]

const RECEIPT_CHARACTERS_PER_LINE = 42;


export interface SectionItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    section_name: string;
    name: string;
  };
}
type NullableString = string | null | undefined;
export interface IPaid {
  amount: string;
  id: number;
  name: string;
  second_name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  name_translation: string;
  attributes: {
    icon: {
      data: {
        id: number;
        attributes: {
          id: number;
          name: string;
          second_name: string;
          image_type: string;
          name_translation: string;
          image: string;
        };
      };
    };
  };
}

interface Meta {
  total_pages: number;
  total_count: number;
  current_page: number;
  next_page: number | undefined;
  pervious_page: number | undefined;
}
export interface ICustomer {
  id: number;
  full_phone_number: string;
  email: string;
  full_name: string;
  customer_profile: {
    street_address: string;
    customer_id: string;
    business_label: string;
    full_address: string;
  };
}

export interface IPermanentTagData {
  id: number;
  tag_code: string;
  prefix: string;
  number: number;
  status: string;
}

export interface IOrderItemTag {
  id: number;
  tag_number: number;
  permanent_tag_number: string;
  permanent_tag_id: number;
  quality_checked: boolean;
  quality_checked_by_id: number | null;
  quality_checked_at: string | null;
  permanent_tag: IPermanentTagData | null;
}

export interface IOrderItem {
  name: string;
  qty: number;
  second_name: string;
  service_short_name: string;
  id: string;
  height: string;
  width: string;
  weight: string;
  attributes: {
    catalogue: {
      id: number;
      name: string;
      product_name: string;
      product_second_name: string;
    };
    notes: string;
    quantity: number;
    no_of_pieces: number;
    unit_price: string;
    total_price: string;
    alert_upcharge: boolean;
    sub_total: string;
    tag_numbers: string[];
    tag_image: {tag_no: string; id: number; url: string; label_string?: string}[];
    order_item_preferences: Array<OrderItemPreferences>;
    service: {
      id: string;
      type: string;
      attributes: {
        id: number;
        name: string;
        second_name: string;
        short_name: string;
        icon_id: number;
        active: boolean;
        online_order: boolean;
        order_number: number;
        service_group_ids: string[];
        icon: {
          data: {
            id: string;
            type: string;
            attributes: {
              id: number;
              name: string;
              second_name: string;
              image_type: string;
              active: boolean;
              image: string;
              image_name: string;
              name_translation: string;
            };
          };
        };
        name_translation: string;
      };
    };
    promotional_info?: {
      is_free_item: boolean;
    };
    order_item_tags?: IOrderItemTag[];
  };
}
export interface IDataItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    adjustment_reason: string | null;
    adjustment_note: string | null;
    credit_order_at:null,
    notes: string;
    customer_complaint: string;
    total: string;
    paid_at: string;
    created_at: Date;
    placed_at: Date;
    currency: string;
    account_id: number;
    order_type: "B2bOrder" | "B2cOrder";
    paid: Array<IPaid>;
    store_name: string;
    is_mobile: boolean;
    customer: ICustomer;
    total_items: number;
    order_number: string;
    total_pieces: number;
    no_of_items?: number;
    no_of_pieces?: number;
    alert_upcharge?: boolean;
    is_quick_drop: boolean;
    internal_status: string;
    is_redeem_receipt?: boolean;
    sub_total: string;
    total_tax: string;
    credit_note?: boolean;
    refund_amount: string;
    tax_percentage: string;
    applied_discount: string;
    order_items: Array<IOrderItem | never>;
    status: string;
    status_plant: string;
    infile_generated: boolean | string;
    colorcode?: string | null;
    parent_order: {
      created_at: string;
      order_number: string;
    } | null;
  };
}

export interface IAdjustOrderItem {
  id: string;
  attributes: {
    id: number;
    order_management_order_id: number;
    quantity: number;
    catalogue_id: number;
    catalogue_variant_id: number;
    customer_preference_id: null;
    preference_id: null;
    service_id: number;
    parent_catalogue_id: null;
    specifications: null;
    category_id: number;
    no_of_pieces: number;
    no_of_tags: number;
    tag_numbers: number[];
    notes: null;
    actual_price: null;
    actual_total_price: null;
    parent_order_item_id: null;
    unit_price: string;
    total_price: string;
    upcharge_price: string;
    catalogue: {
      id: number;
      name: string;
      product_name: string;
      product_second_name: string;
    };
    product_image: null;
    preference: null;
    service: {
      id: string;
      attributes: {
        id: number;
        name: string;
        icon_id: number;
        active: boolean;
        short_name: string;
        second_name: string;
        order_number: number;
        online_order: boolean;
        icon: {
          data: {
            attributes: {
              id: number;
              name: string;
              image: string;
              image_type: string;
              second_name: string;
              name_translation: string;
            };
          };
        };
        name_translation: string;
      };
    };
    parent_order_qty: null;
    alert_upcharge: boolean;
  };
}

export interface IAdjustOrder {
  id: number;
  account_id: number;
  order_number: string;
  sub_total: string;
  total: string;
  status: string;
  price_list_name: string;
  applied_discount: string;
  cancellation_reason: string | null;
  tax_charges: string;
  shipping_charge: string | null;
  shipping_discount: string | null;
  shipping_total: string | null;
  total_tax: string;
  save_for_future: boolean;
  notes: string;
  promo_code_id: string | null;
  store_management_id: number;
  is_quick_drop: boolean;
  address_id: number | null;
  is_mobile: boolean;
  paid_at: string;
  created_at: string;
  refund_amount: string;
  rewash_order: boolean;
  send_to_zatca: boolean;
  adjustment_note: string;
  internal_status: string;
  // is_redeem_receipt: boolean;
   is_redeem_receipt?: boolean;
  adjustment_reason: string;
  adjustment_order: boolean;
  parent_order_id: string | null;
  delivery_address: string | null;
  customer_complaint: string | null;
  adjustment_request: string | null;
  tax_included_in_product_price: boolean;
  order_items: Array<IAdjustOrderItem | never>;
  customer: {
    id: number;
    email: string;
    business: string;
    full_name: string;
    full_address: string;
    full_phone_number: string;
  };
  order_transactions: {
    id: string;
    attributes: {
      id: number;
      account_id: number;
      order_management_order_id: number;
      amount: string;
      payment_method: {
        id: number;
        name: string;
        active: boolean;
        second_name: string;
        name_translation: string;
        attributes: {
          icon: {
            data: {
              id: number;
              attributes: {
                id: number;
                name: string;
                image: string;
                image_type: string;
                second_name: string;
                name_translation: string;
              };
            };
          };
        };
      };
      currency: string;
    };
  }[];
  order_created_by: {
    id: number;
    first_name: string;
    last_name: string;
    full_name: string;
  };
  currency: string;
  store_name: string;
  no_of_items: number;
  no_of_pieces: number;
  tax_percentage: string;
  promo_code?: {
    id: number;
    currency: string;
    discount: string;
    expiry_date: null;
    promo_code: string;
    description: string;
    saved_amount: string;
    max_discount: string;
    promo_expires: boolean;
    min_order_amount: string;
  };
  translated_store_name: string;
  store_second_name: string | null;
  store_management: {
    data: {
      attributes: { id: number; store_name: string };
    };
  };
  invoice_pdf_url: string | null;
  total_upcharge_amount: string;
  driver_account: {
    id: number;
    email: string;
    full_name: string;
    full_phone_number: string;
  };
}

interface IFilterOmitValue extends Omit<IFilter, "value"> {
  value?: string | string[] | Date[] | null | [undefined, undefined];
}
export interface IFilterItem extends Omit<IFilterOmitValue, "apiKey"> {
  apiKey?: string | string[];
}
export interface IOption {
  id: number;
  label: string;
}
export interface IUpChargeItem {
  id: number;
  name: string;
  icon: string;
  price: string;
  checked: boolean;
  currency: string;
  isUpdated?: boolean;
  upcharge_type: string;
  name_translation: string;
}

export interface IPreference {
  id: number;
  name: string;
  icon: string;
  checked: boolean;
  name_translation: string;
}

export interface ISpecOption {
  id: number;
  label: string;
  selected: boolean;
}

export interface ISpecification {
  id: number;
  name: string;
  name_translation: string;
  options_attributes: ISpecOption[];
}

export interface ICustomerSpecs {
  id: string;
  attributes: {
    service: {
      id: string;
      attributes: {
        id: number;
        name: string;
        icon: string;
      };
    };
    product: {
      id: string;
      attributes: {
        id: 972;
        name: string;
      };
    };
    catalogue: {
      id: number;
      attributes: {
        id: number;
        name: string;
        product_name: string;
        product_second_name: string;
      };
    };
    preferences: Array<IPreference | never>;
    specifications: Array<ISpecification | never>;
    upcharge_lists: Array<IUpChargeItem | never>;
  };
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  // Customizable Area Start
  navigation: any;
  id: string;
  // Customizable Area End
}

export interface FooterData {
  id: number;
  phone_number: string;
  website: string;
  social_link: string;
  thank_you_text: string;
  thank_you_text_ar: string;
  footer_image_base64: string;
  type_name: string;
  created_at: string;
  updated_at: string;
}

export interface InvoicesRawData {
  invoice_type: string;
  company_detail: {
    registration_no: string;
    vat_number: string | null;
  };
  store_detail: {
    store_name: string;
    store_id: string | number;
    main_cr_no: string | null;
    store_cr_number: string;
    store_address_arabic: string | null;
    ar_sub_cr_number: string | number | null;
    customer_care: string | null;
    print_invoice_header?: boolean;
  };
  customer_account: {
    full_name: string;
    full_phone_number: string;
    company_name?: string;
    sub_company_name?: string;
    cost_center?: string;
    department?: string;
    department_id?: string;
    employee_id?: string;
    sub_cost_center?: string;
    organazation_name?: string;
    organazation_tax?: string;
  };
  order_created_user: {
    full_name: string;
    first_name_arabic: string;
    last_name_arabic: string;
  };
  order: {
    order_id: number;
    invoice_number: string;
    drop_date: string;
    sub_total: string;
    applied_discount: string;
    taxable_amount: string;
    tax: string;
    total: string;
    note: string | null;
    credit_used: string;
    net_amount: string;
  };
  order_items: Array<{
    id?: number;
    total_incl_vat: string;
    vat: string;
    unit_price: string;
    quantity: number;
    service_name: string;
    product_second_name: string;
    tag_id: string;
    product_name: string;
    sub_total: string;
    product_desc: string;
    notes: string | null;
    upcharge_details: Array<{
      name: string;
      second_name: string;
      upcharge_price: string;
      upcharge_vat: string;
      upcharge_price_without_vat: string;
    }>;
    order_item_tags: Array<{
      tag_number: string;
      permanent_tag_number: string;
    }>;
    preferences: string | null;
    preferences_specifications: string | null;
    promo_item_text_en: string | null;
    promo_item_text_ar: string | null;
    is_golden_point_discount: string | null;
    item_applied_discount: string | null;
    is_golden_discount_applied: boolean;
    order_discount_name_en: string | null;
    order_discount_name_ar: string | null;
    IsPromotionalItem: boolean;
  }>;
  earned_points: number | null;
  used_points: number | null;
  available_points: number | null;
  total_pieces: number;
  order_request_type: "invoice";
  item_services: {
    [key: string]: number;
  };
  qr: string | null;
  barcode_url: string;
  invoice_number_label: string;
  order_label_text: string;
  terms: {
    id: null;
    description: string;
    description_ar: string;
  } | null;
  logo?: string | null;
  header_logo_base64?: string | null;
  footer_image_base64?: string | null;
  footer: FooterData | null;
  is_b2b_order: boolean;
  promotions?: boolean;
}

export interface S {
  // Customizable Area Start
  txtInputValue: string;
  txtSavedValue: string;
  isb2c:boolean;
  orderToPrint: InvoicesRawData | null;
  enableField: boolean;
  plantSection: string | undefined;
  selectedDate: Date | null | string | undefined;
  searchQuery: string;
  searchResult: boolean;
  searchTextQuery: string;
  isScanGarmentTag: boolean
  sortingQuery: string;
  isLoadingOrderItems: boolean;
  isScanningOrder: boolean;
  isUpdateStatusLoading: boolean;
  isLoadingSharedFolder: boolean;
  orderItems: Array<IOrderItem | never>;
  modalOrderItems: Array<IOrderItem | never>;
  itemsToPrint: Array<IOrderItem>;
  orderData: IDataItem | null;
  selectedOrders: Array<number | never>;
  selectedOption: string | null;
  selectAllStoreId:
   {id:string,option:string} | undefined;
  orderList: Array<IDataItem | never>;
  meta: {
    total_pages: number;
    total_count: number;
    current_page: number;
  };
  sortingData: ISortingData;
  snackbarMessage: string;
  scanInput:string,
  selectedBranches: Array<number>;
  branchList: Array<IOption>;
  selectedTab: number;
  isPermittedPage: boolean;
  adjustmentList: Array<IOption | never>;
  filters: IFilterItem[];
  filterAnchor: { currentTarget: {} } | undefined | HTMLDivElement;
  suggestionFieldTitle: string;
  isPrintShow: boolean;
  showResendButton: boolean;
  selectedAdjustmentReason: string | undefined;
  adjustmentComment: string;
  adjustmentError: boolean;
  adjustMentErrorModal: boolean;
  isDrawerOpen: boolean;
  isPlantLoading: boolean;
  isOrderListLoading: boolean;
  changeProductModal: boolean;
  adjustmentOrderModal: boolean;
  adjustmentRequestType?: string;
  adjustmentRequestTypeSub: string;
  editOrderPopupFromAdjustment: boolean;
  reviewOrderPopupFromAdjustment: boolean;
  adjustOrder: IlaundryOrder | null;
  adjustOrignleOrder: IlaundryOrder | null;
  adjustOrderItems: IItemData[];
  isCreditNoteDialogOpen: boolean;
  adjustmentReasonId: string;
  taxAmount: string;
  adjustmentAmount: string;
  addNote: string;
  isConfirmationChecked: boolean;
  cartTotalOpen: boolean;
  adjustmentCancelOrderModal: boolean;
  adjustmentSelectUpChargeModal: boolean;
  adjustmentCancelOrderMessage: string;
  orignalOrderId: number | null;
  userData: IMyUser | null;
  cataloguesDataList: CatalogueDataList[];
  cataloguesListMeta: Meta;
  tabsId: number;
  regionId: number | null
  currentPage: number;
  adjustCartProduct: Array<IAdjustCartProduct>;
  preferenceData: IpreferenceData | null;
  preferenceModalVisible: boolean;
  selectedService: SelectedService | null;
  orderUpChargePreference: Array<ICustomerSpecs | never>;
  sameProductDifferentServiceModalOpen: boolean;
  isIncreaseBtnClicked: boolean;
  clickedProductCardInfo: IAdjustCartProduct | null;
  originalAdjustOrderId: string;
  subProductModal: boolean;
  clickedParentCatalougeId: number | null;
  creditNoteOrder?: IDataItem;
  creditNotePresent?: boolean;
  hidden: boolean;
  creditLoader: boolean;
  creditNoteReceipt: string;
  adjustmentOrignalOrderNumber: string;
  cartsItemsPreferencesData: CartsItemsPreferencesData[];
  storeManagementDetails: StoreManagementDetails | null;

  productPopup: boolean;
  carpetFurnitureProductPopupData: CatalogueDataList | null;
  selectedCatalogueData: CatalogueDataList | null;
  palntPermissionStatus: PlantPermissionStatus;
  isPopuDisabledWithOrderCreate: boolean;

  searchCatalogue: string;
  isCatalogueCardLoading: boolean;
  catalogueListEmptyFlag: boolean;
  customerPriceListId: number | null;
  snackBarSeverity: 'error' | 'success';
  sectionList: { attributes: { section_name: string; id: number } }[];
  creditNoteOrderNumber: number | null;
  openCrediNoteModalLoader: boolean;

  isAutoSend: boolean;
  isAppliedFilter: boolean;
  adjustRemark: string;

  onloadReduceApiCall:boolean;
  isB2bMode: boolean;
  isEditTagMode: boolean,
  editableTagValues: { [key: string]: string },
  currentMapTagIndex: number,
  isLinkingPermanentTag: boolean
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class Cfplantdashboard2Controller extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  storeListMessageId: string = "";
  plantOrderListMessageId: string = "";
  updateOrderListMessageId: string = "";
  getOrderItemsListMessageId: string = "";
  adjustmentReasonListMessageId: string = "";
  filterOrderSuggestionApiCallId: string = "";
  filterCustomerSuggestionApiCallId: string = "";
  getCreateNewOrderApiCallID: string = "";
  updateOrderApiCallID: string = "";
  getCatalogueListAPICallID: string = "";
  getStoreManagementDetailsAPICallID: string = "";
  getPreferencesDataApiCallId: string = "";
  createPreferencesApicallId: string = "";
  scanOrderApiCallId: string = "";
  linkPermanentTagApiCallId: string = "";
  unlinkPermanentTagApiCallId: string = "";
  sendOrderToClanApiCallId: string = "";
  getSectionListId: string = "";
  deleteAdjustmentOrderMessageId: string = "";
  goldenPointBackupOrder: string ="";
  getRawOrderInvoiceDataCallId: string = "";
  savedRawPrintDatasMap = new Map<string, InvoiceRawData>()

  autoMoveToShortingAreaData: {
    apiCallId: string,
    nextOrder: IDataItem
  } | null = null

  ADJUSTMENT_TYPES = {
    ADD_QUANTITY: configJSON.adjustmentPopup_add_quantity,
    MINUS_QUANTITY: configJSON.adjustmentPopup_minus_quantity,
    ADD_NEW_PRODUCT: configJSON.adjustmentPopup_add_new_product,
    CHANGE_PRODUCT: configJSON.adjustmentPopup_change_product,
    REMOVE_PRODUCT: configJSON.adjustmentPopup_remove_product,
    ADD_UPCHARGE: configJSON.adjustmentPopup_add_upcharge,
    CHANGE_UPCHARGE: configJSON.adjustmentPopup_change_upcharge,
    REMOVE_UPCHARGE: configJSON.adjustmentPopup_remove_upcharge,
    FULL_UNDONE: configJSON.adjustmentPopup_full_undone,
    PARTIAL_UNDONE: configJSON.adjustmentPopup_partial_undone,
    CANCEL_ORDER: configJSON.editOrderPopup_text_cancel,
  };

  getUpdateOrderMessageId = "";
  getAdjustOrderMessageId = "";
  getCreditNoteMessageId = "";
  adjustOrderConfirmMessageId = "";
  checkForOrderCanceledMessageId = "";
  getAdjustOrderItemMessageId = "";
  getCreateCreditNoteMessageId = "";
  getUpdateUpChargePreferenceMessageId = "";
  getAdjustmentCancelOrFullUndoneMessageId = "";
  getSharedFolderMessageId = "";
  getFilesForAutoSendMessageId = "";

  shouldPrintTag = false;
  disableToggleAutoSend = false;
  disableGetFiles = false;
  autoSendFiles: ReturnType<typeof setInterval> | undefined = undefined
  isMoreFilesToSend = false;
  filesWrittenByResend = new Set<string>();
  filesWrittenByAutosend = new Set<string>();
  updateInFilesAfterResendCallId = "";
  updateInFilesAfterAutoSendCallId = "";
 verificationFolderPaths = new Set<string>();
 verifyInFilesCallId = "";

  // Refs for order item rows to enable auto-scroll
  orderItemRowRefs: Map<number, HTMLDivElement | null> = new Map();
  // Track pending scroll index after order items refresh
  pendingScrollIndex: number | null = null;
  // Flag to recalculate first unmapped index after refresh (used after unlink)
  shouldRecalculateMapIndex: boolean = false;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getCustomEnumName(CustomEnums.DataForRedirectionFromNotification),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage),
      getName(MessageEnum.BroadcastNavbarDataMessage),
      // Customizable Area End
    ];

    // Customizable Area Start
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);

    if (message.id === getName(MessageEnum.AccoutLoginSuccess)) {
      let value = message.getData(getName(MessageEnum.AuthTokenDataMessage));

      this.showAlert(
        "Change Value",
        "From: " + this.state.txtSavedValue + " To: " + value
      );

      this.setState({ txtSavedValue: value });
    }

    // Customizable Area Start
    this.handleScanOrderResponse(message);
    this.handleLinkPermanentTagResponse(message);
    this.handleUnlinkPermanentTagResponse(message);
    this.handleAutoMoveToShortingAreaResponse(message);
    this.handleGetFilesForAutoSendResponse(message);
    this.handleGetSharedFolderDataResponse(message);
    this.handleUpdateInFilesResponse(message);
    this.handleVerifyInFilesResponse(message);
    this.handleUpChargeOrder(message);
    this.handleUpChargeForPreference(message);
    this.handlePlatOrderListApiResponse(message);
    this.handelAdjustmentListApiResponse(message);
    this.handleFilterOrderSuggestionResp(message);
    this.handleAdjustOrderGetApiResponse(message);
    this.handlePlatOrderUpdateApiResponse(message);
    this.handelGetOrderItemListApiResponse(message);
    this.handleFilterCustomerSuggestionResp(message);
    this.handleCreateNewOrderResp(message);
    this.handleCatalougeListResp(message);
    this.handlePreferencesListResp(message);
    this.handleUpdateOrderResp(message);
    this.handleConfirmOrderResponse(message);
    this.handleCheckCanceledOrderResponse(message);
    this.handleCreditNoteResponse(message);
    this.handleStoreManagementDetailsResponse(message);
    this.handleGetRawInvoiceResponse(message);
    this.handleSendOrderToCleanResponse(message);
    this.handleSectionListAPIResponse(message);
    this.receiveDataFromLayout(message);
    this.receiveSearchText(message);
    this.receiveDataFromHeader(message)

    if (
      message.id === getCustomEnumName(CustomEnums.DataForRedirectionFromNotification)
    ) {
      const {
        order_number,
        store_management_id
      } = message.properties.orderData;
      this.setState({
        selectedTab: 1, // redirect to receiving_area when click on go to adjustment btn from notification
      }, () => {
        setTimeout(() => this.getOrderList("receiving_area", 1, [store_management_id], order_number), 1000);
      })
    }
    // Customizable Area End
  }

  setEmptySearchHeaderText = () => {
    let msgData = new Message(getName(MessageEnum.setEmptyHeaderSearchMessage));
    this.send(msgData)
  };
  txtInputWebProps = {
    onChangeText: (text: string) => {
      this.setState({ txtInputValue: text });
    },
    secureTextEntry: false,
  };

  txtInputMobileProps = {
    ...this.txtInputWebProps,
    autoCompleteType: "email",
    keyboardType: "email-address",
  };

  txtInputProps = this.isPlatformWeb()
    ? this.txtInputWebProps
    : this.txtInputMobileProps;

  btnShowHideProps = {
    onPress: () => {
      this.setState({ enableField: !this.state.enableField });
      this.txtInputProps.secureTextEntry = !this.state.enableField;
      this.btnShowHideImageProps.source = this.txtInputProps.secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  btnShowHideImageProps = {
    source: this.txtInputProps.secureTextEntry
      ? imgPasswordVisible
      : imgPasswordInVisible,
  };

  btnExampleProps = {
    onPress: () => this.doButtonPressed(),
  };

  doButtonPressed() {
    let msg = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(
      getName(MessageEnum.AuthTokenDataMessage),
      this.state.txtInputValue
    );
    this.send(msg);
  }

  // web events
  setInputValue = (text: string) => {
    this.setState({ txtInputValue: text });
  };

  setEnableField = () => {
    this.setState({ enableField: !this.state.enableField });
  };

  // Customizable Area Start

  getObjectIndexByApiKey=(apiKey:string)=> {
    let dataTab = this.getTabList()
    return dataTab.findIndex(item => item.apiKey === apiKey);
  }

  receiveDataFromHeader = (message: Message) => {
    if (message.id === getName(MessageEnum.BroadcastNavbarDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.BroadcastNavbarData)
      );
      const { storeId } = recievedData;
      if (storeId && !isEqual(this.state.selectedBranches, storeId.split(','))) {
        this.setState({ selectedBranches: storeId.split(',') }, () => {
          if (this.state.onloadReduceApiCall) {
            this.getOrderList(this.getCurrentSelectedTab().apiKey, 1);
          }
        });
      }
    }
  }

  receiveSearchText = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.SearchMessageText)
        );
        if (recievedData) {
          this.handleSearchText(recievedData.searchText)
        }
    }
  }
  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.LayoutMessageData)
        );
        if (recievedData.userContext) {
          this.handleOpenedChange(recievedData.isDrawerOpen);
          this.handleOnUserChange(recievedData.userContext)
        }
    }
  }

  getSortingProps() {
    return {
      sortingData: this.state.sortingData,
      onQueryChange: (varUrl: string) => {
        this.setState({ sortingQuery: varUrl });
        this.getOrderList(
          this.getCurrentSelectedTab().apiKey,
          this.state.meta.current_page,
          this.state.selectedBranches,
          this.state.searchQuery,
          varUrl
        );
      },
      onChange: (data: ISortingData) => this.setState({ sortingData: data }),
    };
  }

  async componentDidMount() {
    super.componentDidMount();
    this.setEmptySearchHeaderText()
    this.setState({ isPlantLoading: true });
    this.setState({
      isDrawerOpen: (await getStorageData("isPinned")) == "true",
      isb2c:(await getStorageData("accountType")) == "b2c",
    });

    this.handleStorageFilter();
  }

  handleStorageFilter = () => {
    const applied_plant_dashboard_filter = localStorage.getItem("plant_dashboard_filter_value");
    if(applied_plant_dashboard_filter) {
      this.setState({
        filters: JSON.parse(applied_plant_dashboard_filter),
        isAppliedFilter: checkIsFilterApplied(JSON.parse(applied_plant_dashboard_filter))
      });
    };
  };

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<S>): void {
    if (!this.state.isPlantLoading) {
      if (prevState.isPlantLoading) {
        if (this.isShortingAreaTab() && !this.autoSendFiles) {
          this.turnOnAutoSendMode()
        }
      }
      if (prevState.selectedTab !== this.state.selectedTab) {
        const permittedTabs = this.getTabList().filter(section => section.permitted);
        const prevTabData = permittedTabs[prevState.selectedTab];
        if (this.isShortingAreaTab() && !this.state.isAutoSend) {
          // Switching to shorting area - turn ON auto send
          this.turnOnAutoSendMode()
        } else if (prevTabData?.apiKey === "shorting_area" && !this.isShortingAreaTab() && this.state.isAutoSend) {
          // Switching away from shorting area - turn OFF auto send
          this.turnOffAutoSendMode()
        }
      }
    }
    this.updateDataSharedFilterBasedOnTab()
  }

  updateDataSharedFilterBasedOnTab = () => {
    const isCurrentTab4 = this.getCurrentSelectedTab().tabId === 4;

    const dataSharedFilter: IFilterItem = {
      title: "Data Shared",
      type: "select",
      value: "",
      apiKey: "data_shared",
      options: DATA_SHARED_FILTER_OPTIONS,
    };

    const conveyerDataSharedFilter: IFilterItem = {
      title: "Conveyer Data Shared",
      type: "select",
      value: "",
      apiKey: "conveyer_data_shared",
      options: CONVEYER_DATA_SHARED_FILTER_OPTIONS,
    };

    const dataSharedFilterExists = this.state.filters.some(
      (f) => f.apiKey === "data_shared"
    );

    const conveyerFilterExists = this.state.filters.some(
      (f) => f.apiKey === "conveyer_data_shared"
    );

    if ((isCurrentTab4 && !dataSharedFilterExists) || (!isCurrentTab4 && dataSharedFilterExists) ||
        (isCurrentTab4 && !conveyerFilterExists) || (!isCurrentTab4 && conveyerFilterExists)) {
      this.setState((prevState) => {
        let newFilters = prevState.filters;

        if (isCurrentTab4) {
          // Add filters if they don't exist
          if (!dataSharedFilterExists) {
            newFilters = [...newFilters, dataSharedFilter];
          }
          if (!conveyerFilterExists) {
            newFilters = [...newFilters, conveyerDataSharedFilter];
          }
        } else {
          // Remove filters
          newFilters = newFilters.filter((f) => f.apiKey !== "data_shared" && f.apiKey !== "conveyer_data_shared");
        }

        return { filters: newFilters };
      });
    }
  };
  

  async componentWillUnmount() {
    super.componentWillUnmount();
    clearInterval(this.autoSendFiles)
  }

  handleFilterChange = (filters: IFilter[]) => {
    // set filter applied value set
    if (checkIsFilterApplied(filters)) {
      localStorage.setItem("plant_dashboard_filter_value", JSON.stringify(filters));
    } else {
      localStorage.removeItem("plant_dashboard_filter_value");
    };

    this.setState(
      {
        filters,
        isAppliedFilter: checkIsFilterApplied(filters)
      },
      () => this.getOrderList(this.getCurrentSelectedTab().apiKey, 1)
    );
  };

  handelAdjustmentListApiResponse(message: Message) {
    if (
      this.adjustmentReasonListMessageId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      // clear so a failed/empty fetch can be retried on the next open
      this.adjustmentReasonListMessageId = "";
      if (response?.data) {
        this.setState({ adjustmentList: response.data });
      }
    }
  }

  handelGetOrderItemListApiResponse(message: Message) {
    if (
      this.getOrderItemsListMessageId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const newOrderItems = this.handleNoTagsOrdersItems(response.data)

      // Check if we need to recalculate the first unmapped index (after unlink)
      let newMapIndex: number | undefined;
      if (this.shouldRecalculateMapIndex && this.state.isEditTagMode) {
        const firstUnmappedIndex = newOrderItems.findIndex(
          (item: IOrderItem) => !item.attributes.order_item_tags?.[0]?.permanent_tag?.tag_code
        );
        newMapIndex = firstUnmappedIndex >= 0 ? firstUnmappedIndex : newOrderItems.length;
        this.pendingScrollIndex = newMapIndex;
        this.shouldRecalculateMapIndex = false;
      }

      const stateUpdate: Partial<S> = {
        orderItems: newOrderItems,
        modalOrderItems: response.data,
        isLoadingOrderItems: false
      };
      if (newMapIndex !== undefined) {
        stateUpdate.currentMapTagIndex = newMapIndex;
      }

      this.setState(stateUpdate as Pick<S, keyof S>, () => {
        // Execute pending scroll after order items are loaded and rendered
        if (this.pendingScrollIndex !== null) {
          this.scrollToOrderItem(this.pendingScrollIndex);
          this.pendingScrollIndex = null;
        }
      });
      if (this.shouldPrintTag) {
        this.handlePrintTag(newOrderItems);
      }
      this.shouldPrintTag = false
    }
  }

  handlePlatOrderListApiResponse(message: Message) {
    if (
      this.plantOrderListMessageId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      let tabId = this.state.selectedTab;
      if(response.data.length > 0){
        let index = this.getObjectIndexByApiKey(response.data[0].attributes.status_plant)
        tabId = sortCondition(this.state.searchResult,index,this.state.selectedTab) as number
      }
      response?.data &&
        this.setState({
          orderList: response.data as Array<IDataItem | never>,
          meta: response.meta,
          isPlantLoading: false,
          isOrderListLoading: false,
          isUpdateStatusLoading: false,
          searchResult: false,
          selectedTab: tabId as number
        });

      this.setState({
        selectedOption: null,
        selectedOrders: [],
        showResendButton: response?.data?.[0]?.attributes?.status_plant === "shorting_area" 
      });
    }
  }

  handlePlatOrderUpdateApiResponse(message: Message) {
    if (
      this.updateOrderListMessageId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (response.status === 200) {
        this.onCloseDetailsModal();
        this.setState({isUpdateStatusLoading:false})
        this.getOrderList(this.getCurrentSelectedTab().apiKey)
      }
    }
  }

  getOrderList(
    status = "at_store",
    page = this.state.meta.current_page,
    branches = this.state.selectedBranches,
    query = this.state.searchTextQuery,
    sortingQuery = this.state.sortingQuery
  ) {
    this.setState({isOrderListLoading: true})
    const { plantSection } = this.state;
    const varSort = sortingQuery ? "&" + sortingQuery : "";
    const queryForSearch = query ? `&filter_by[query]=${query}` : "";

    const orderLabel = this.state.filters.find(
      (item: IFilterItem) => item.title === "Order ID"
    )?.value;
    const orderOptions = this.state.filters.find(
      (item: IFilterItem) => item.title === "Order ID"
    )?.options;
    const order = orderOptions?.find(
      (item: { label: string }) => item.label == orderLabel
    );
    const order_id = order ? order?.value : "";

    const customerLabel = this.state.filters.find(
      (item: IFilterItem) => item.title === "Customer"
    )?.value;
    const customerOptions = this.state.filters.find(
      (item: IFilterItem) => item.title === "Customer"
    )?.options;
    const customer = customerOptions?.find(
      (item: { label: string }) => item.label == customerLabel
    );
    const customer_id = customer ? customer?.value : "";

    const Date = this.state.filters.find(
      (item: { title: string }) => item.title === "Date"
    )?.value;

    let sectionQuery: string = "";
    const sectionFilter = this.state.filters.find(
      (item) => item.title === "Section"
    );

    const dataSharedFilter = this.state.filters.find(
      (item) => item.apiKey === "data_shared"
    );
    const sharedData = dataSharedFilter?.value;

    const conveyerDataSharedFilter = this.state.filters.find(
      (item) => item.apiKey === "conveyer_data_shared"
    );
    const conveyerDataShared = conveyerDataSharedFilter?.value;

    if (sectionFilter && sectionFilter.value && sectionFilter.value.length) {
      sectionQuery = (sectionFilter.value as string[]).reduce(
        (param: string, varc: string) => param + "&filter_by[section_ids][]=" + varc,
        ""
      );
    }

    const plantListUrl =
      configJSON.plantOrderListEndPoint2 +
      sortCondition(this.state.searchResult,"?",`?filter_by[status_plant]=${(plantSection || status)}&`) +
      `page_no=${page}&per_page=50&store_ids=${branches
        .filter((index) => index)
        .join(",")}${queryForSearch}${varSort}${sectionQuery}` +
      (order_id ? `&filter_by[order_id]=${order_id}` : "") +
      (customer_id ? `&filter_by[customer_id]=${customer_id}` : "") +
      (sharedData && sharedData !== "" ? `&filter_by[infile_generated]=${sharedData}` : "")+
      (conveyerDataShared && conveyerDataShared !== "" ? `&conveyor_file_status=${conveyerDataShared}` : "")+
      (Date ? `&filter_by[order_date]=${encodeURIComponent(getDateRangeForQuery(Date as string).startDate)}` : "");
    const message = makeApiMessage({
      method: "GET",
      url: plantListUrl,
    });

    this.plantOrderListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

   scanOrderDetails(
    status = "scan_garment_tag",
    page = this.state.meta.current_page,
    branches = this.state.selectedBranches,
    query = this.state.searchTextQuery,
    sortingQuery = this.state.sortingQuery
  ) {
    this.setState({isOrderListLoading: true})
    const { plantSection } = this.state;
    const varSort = sortingQuery ? "&" + sortingQuery : "";
    const queryForSearch = query ? `&filter_by[query]=${query}` : "";

    const orderLabel = this.state.filters.find(
      (item: IFilterItem) => item.title === "Order ID"
    )?.value;
    const orderOptions = this.state.filters.find(
      (item: IFilterItem) => item.title === "Order ID"
    )?.options;
    const order = orderOptions?.find(
      (item: { label: string }) => item.label == orderLabel
    );
    const order_id = order ? order?.value : "";

    const customerLabel = this.state.filters.find(
      (item: IFilterItem) => item.title === "Customer"
    )?.value;
    const customerOptions = this.state.filters.find(
      (item: IFilterItem) => item.title === "Customer"
    )?.options;
    const customer = customerOptions?.find(
      (item: { label: string }) => item.label == customerLabel
    );
    const customer_id = customer ? customer?.value : "";

    const Date = this.state.filters.find(
      (item: { title: string }) => item.title === "Date"
    )?.value;

    let sectionQuery: string = "";
    const sectionFilter = this.state.filters.find(
      (item) => item.title === "Section"
    );

    const sharedData = this.state.filters.find(
      (item) => item.title === "Data Shared"
    )?.value;
    
    if (sectionFilter && sectionFilter.value && sectionFilter.value.length) {
      sectionQuery = (sectionFilter.value as string[]).reduce(
        (param: string, varc: string) => param + "&filter_by[section_ids][]=" + varc,
        ""
      );
    }

    const plantListUrl =
      configJSON.plantOrderListEndPoint2 +
      sortCondition(this.state.searchResult,"?",`?filter_by[status_plant]=${(plantSection || status)}&`) +
      `page_no=${page}&per_page=50&store_ids=${branches
        .filter((index) => index)
        .join(",")}${queryForSearch}${varSort}${sectionQuery}` +
      (order_id ? `&filter_by[order_id]=${order_id}` : "") +
      (customer_id ? `&filter_by[customer_id]=${customer_id}` : "") +
      (sharedData ? `&filter_by[infile_generated]=${sharedData}` : "")+
      (Date ? `&filter_by[order_date]=${encodeURIComponent(getDateRangeForQuery(Date as string).startDate)}` : "");
    const message = makeApiMessage({
      method: "GET",
      url: plantListUrl,
    });

    this.plantOrderListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleSearchText = (query:string) => {
    if(!this.state.isPermittedPage){
      this.setState({searchTextQuery:query,searchResult:sortCondition(Boolean(query),true,false) as boolean})
      this.getOrderList(
        this.getCurrentSelectedTab().apiKey,
        1,
        this.state.selectedBranches,
        query
      )
    }    
  }

  getOrderItemsList(varId: string) {
    const message = makeApiMessage({
      method: "GET",
      url: configJSON.getOrderItemsList + varId,
    });

    this.setState({
      orderItems: [],
      modalOrderItems: [],
      isLoadingOrderItems: true
    });
    this.getOrderItemsListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  getAdjustmentReasonList() {
    // Static dropdown: fetch once per mount, not on every Details click.
    if (this.state.adjustmentList.length > 0 || this.adjustmentReasonListMessageId) return;
    const message = makeApiMessage({
      method: "GET",
      url: configJSON.getAdjustmentReasonList,
    });

    this.adjustmentReasonListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }



  debouncedFunction = debounce(
    (newInputValue: string, inputFunction: (inputValue: string) => void) => inputFunction(newInputValue),
        700    
    );

  getCurrentSelectedTab() {
    const { selectedTab } = this.state;
    // Get permitted tabs to match UI indices
    const permittedTabs = this.getTabList().filter(section => section.permitted);
    return permittedTabs[selectedTab] || this.getTabList()[selectedTab];
  }

  getNextPlantActionTab() {
    const { selectedTab } = this.state;
    let tabId;
    if (selectedTab === 5 || selectedTab === 6) {
      tabId = 0;
    } else {
      tabId = selectedTab + 1;
    }
    return this.getTabList()[tabId];
  }

  getTabList(isTabs: boolean = false) {
    const { plantSection,palntPermissionStatus } = this.state;

    const sections = [
      {
        label: configJSON.stringsListPage_tab_store,
        apiKey: "at_store",
        tabId: configJSON.store_tab_id,
        dropId: 0,
        showDropItems: [],
        permitted: palntPermissionStatus.storeAccessPermission,
        actionPermitted: palntPermissionStatus.storeActionPermission
      },
      {
        label: configJSON.stringsListPage_tab_receivingArea,
        apiKey: "receiving_area",
        tabId: configJSON.receiving_area_tab_id,
        dropId: 1,
        showDropItems: [
          configJSON.store_tab_id,
          configJSON.shorting_area_tab_id,
          configJSON.loading_area_tab_id,
          configJSON.dispatched_tab_id,
          configJSON.adjustment_tab_id,
        ],
        permitted: palntPermissionStatus.receivingAreaAccessPermission,
        actionPermitted: palntPermissionStatus.receivingAreaActionPermission
      },      
      {
        label: configJSON.stringsListPage_tab_sortingArea,
        apiKey: "shorting_area",
        tabId: configJSON.shorting_area_tab_id,
        dropId: 2,
        showDropItems: [
          configJSON.store_tab_id,
          configJSON.receiving_area_tab_id,
          configJSON.loading_area_tab_id,
          configJSON.dispatched_tab_id,
          configJSON.adjustment_tab_id
        ],
        permitted: palntPermissionStatus.shortingAreaAccessPermission,
        actionPermitted: palntPermissionStatus.shortingAreaActionPermission
      },
      {
        label: configJSON.stringsListPage_tab_loadingArea,
        apiKey: "loading_area",
        tabId: configJSON.loading_area_tab_id,
        dropId: 3,
        showDropItems: [
          configJSON.store_tab_id,
          configJSON.receiving_area_tab_id,
          configJSON.shorting_area_tab_id,
          configJSON.dispatched_tab_id,
          configJSON.adjustment_tab_id
        ],
        permitted: palntPermissionStatus.loadingAreaAccessPermission,
        actionPermitted: palntPermissionStatus.loadingAreaActionPermission
      },
      {
        label: configJSON.stringsListPage_tab_dispatched,
        apiKey: "dispatched",
        tabId: configJSON.dispatched_tab_id,
        dropId: 4,
        showDropItems: [
          configJSON.store_tab_id,
          configJSON.receiving_area_tab_id,
          configJSON.shorting_area_tab_id,
          configJSON.loading_area_tab_id,
          configJSON.adjustment_tab_id
        ],
        permitted: palntPermissionStatus.dispatchedAccessPermission,
        actionPermitted: palntPermissionStatus.dispatchedActionPermission
      },
      {
        label: configJSON.stringsListPage_tab_adjustment,
        apiKey: "adjustment",
        tabId: configJSON.adjustment_tab_id,
        dropId: 5,
        showDropItems: [
          configJSON.receiving_area_tab_id
        ],
        permitted: palntPermissionStatus.adjustmentAccessPermission,
        actionPermitted: palntPermissionStatus.adjustmentActionPermission
      },
         {
        label: configJSON.stringsListPage_tab_scanGarmentTag,
        apiKey: "scan_garment_tag",
        tabId: configJSON.scan_garment_tab_id,
        dropId: 6,
        showDropItems: [
          configJSON.store_tab_id,
          configJSON.shorting_area_tab_id,
          configJSON.loading_area_tab_id,
          configJSON.dispatched_tab_id,
          configJSON.adjustment_tab_id,
        ],
        permitted: palntPermissionStatus.scanGarmentAccessPermission,
        actionPermitted: palntPermissionStatus.scanGarmentActionPermission
      },    
    ];
    return plantSection && isTabs
      ? sections.filter((item) => item.apiKey === plantSection)
      : sections;
  }

  onChangeTabs(index: number) {
    const { plantSection } = this.state;
    // Get permitted tabs to match UI indices
    const permittedTabs = this.getTabList().filter(section => section.permitted);
    const selectedTabData = permittedTabs[index];

    const tabId =
      plantSection == ""
        ? index
        : this.handlePlantSectionTab(plantSection as string);
    this.setState({
      selectedTab: tabId,
      selectedOption: null,
      selectedOrders: [],
    });
   if (Number(index) !== 6) {
  this.getOrderList(this.getTabList()[Number(index)].apiKey);
    // Find the original index in full tab list for ClickonSorting
    const originalIndex = this.getTabList().findIndex(tab => tab.apiKey === selectedTabData?.apiKey);
  this.ClickonSorting(Number(index));
}
  
  }

  ClickonSorting(index: number){
    if(this.getTabList()[index].apiKey === 'shorting_area'){ 
      if(!qzTray.websocket.isActive()) {
        this.setState({snackbarMessage : configJSON.connectionErrorMessage,snackBarSeverity: "error"})
         return;
       }
      this.getFilesForAutoSend() 
    }
  }

  errorMessageData() {
    this.getFilesForAutoSend()
    this.ClickonSorting(2);
    this.setState({
      snackbarMessage: configJSON.connectionErrorMessage,
      snackBarSeverity: "error"
    })
  }


  isAdjustmentTabLoad() {
    return (
      this.getCurrentSelectedTab().apiKey == "adjustment" ||
      this.state.plantSection === "adjustment"
    );
  }

  isShortingAreaTab = () => this.getCurrentSelectedTab().apiKey === "shorting_area"

  onSelectAllOrders() {
    const { orderList, selectedOrders } = this.state;
    const isSelectedAll = orderList.length === selectedOrders.length;
    if (isSelectedAll) {
      this.setState({ selectedOrders: [] });
    } else {
      this.setState({
        selectedOrders: orderList
          .filter((item: IDataItem) => item.attributes.status !== 'cancelled')
          .map((item: IDataItem) => item.attributes.id),
      });
    }
  }

  isShowNextLabel() {
    const isAdjustMentPlant = this.state.plantSection === "adjustment";
    if (
      this.getCurrentSelectedTab().tabId == 7 ||
      this.getCurrentSelectedTab().tabId == 6 ||
      isAdjustMentPlant
    ) {
      return false;
    } else {
      return true;
    }
  }

  onToggleOrderSelection(varId: number, status:string) {
    if(status==='cancelled')
    {
      return
    }
    let array: number[] = JSON.parse(JSON.stringify(this.state.selectedOrders));
    if (array.includes(varId)) {
      array = array.filter((item: number) => item != varId);
    } else array.push(varId);

    this.setState({ selectedOrders: array });
  }

  checkboxClass= (status:string)=>{
    if(status === "cancelled") 
    return "cursor-notallowed"
    else 
    return"cursor-pointer"
  }

  onUpdateAdjustmentOrders() {
    const { selectedOrders, selectedOption } = this.state;
    this.setState({isUpdateStatusLoading:true})
    const adjustmentBody = JSON.stringify({
      status: selectedOption,
      order_ids: selectedOrders,
      adjustment_reason: this.state.selectedAdjustmentReason,
      adjustment_note: this.state.adjustmentComment,
    });

    const message = makeApiMessage({
      url: configJSON.plantOrderUpdateEndPoint,
      method: "PATCH",
      body: adjustmentBody,
    });

    this.updateOrderListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleAdustmentOrderStatus() {
    const { selectedOrders } = this.state;

    if (selectedOrders.length > 1) {
      this.setState({ adjustMentErrorModal: true });
    } else {
      const order = this.state.orderList.find(
        (item: IDataItem) => item.attributes.id === selectedOrders[0]
      );
      this.setState({ orderData: order as IDataItem });
      this.getOrderItemsList(selectedOrders[0].toString());
    }
  }

  onUpdateOrders() {
    const { selectedOrders, selectedOption } = this.state;

    if(selectedOrders.length > 0) {
      const body = JSON.stringify({
        status: selectedOption,
        order_ids: selectedOrders,
      });
  
      const isAdjustment = selectedOption === "adjustment";
  
      if (isAdjustment) {
        this.handleAdustmentOrderStatus();
        this.getAdjustmentReasonList();
      } else {
        this.setState({isUpdateStatusLoading:true})
        const message = makeApiMessage({
          url: configJSON.plantOrderUpdateEndPoint,
          method: "PATCH",
          body: body,
        });
  
        this.updateOrderListMessageId = message.messageId;
        runEngine.sendMessage(message.id, message);
      }
    }else{
      this.setState({snackbarMessage: "Please select the order",  snackBarSeverity: 'error'})
    }

  }

  onChangePage(page: number) {
    this.getOrderList(this.getCurrentSelectedTab().apiKey, page);
  }

  onCancel() {
    this.setState({ selectedOption: null, selectedOrders: [] });
  }

  onOpenOrderDetails(order: IDataItem) {
    // When mapping mode is active and a new order is opened,
    // recalculate the first unmapped index for the new order
    if (this.state.isEditTagMode) {
      this.shouldRecalculateMapIndex = true;
    }
    this.setState({ orderData: order });
    this.getOrderItemsList(order.id);
    this.getAdjustmentReasonList();
  }

  onChangeSelectedOption(value: string) {
    this.setState({ selectedOption: value, selectedOrders: [] });
  }

  onChangeSelectedAdjustmentReason(value: string) {
    let label = this.state.adjustmentList.find(
      (reason: IOption) => reason.id === Number(value)
    )?.label;
    this.setState({
      selectedAdjustmentReason: label as string,
      adjustmentError: false,
    });
  }

  onUserChange(storeId?: number) {
        this.setState(
      {
        selectedOrders: [],
        selectedOption: null,
      },
      () => {
        setTimeout(() => {
          this.setState({onloadReduceApiCall:true})
        }, 1000);
        const permittedSections =  this.getTabList().filter(section => section.permitted);
        if(permittedSections.length > 0){
          this.getOrderList(permittedSections[0].apiKey, 1, this.state.selectedBranches);
          this.setState({selectedTab: permittedSections[0].dropId})
        }else{
          this.setState({isPermittedPage: true})
        }
      }
    );
  }

  onCloseSnackBar() {
    this.setState({ snackbarMessage: "" });
  }

  onCloseDetailsModal() {
    this.setState({
      orderData: null,
      selectedAdjustmentReason: "",
      adjustmentComment: "",
      selectedOrders: [],
      selectedOption: "",
      isPrintShow: false,
      itemsToPrint: [],
      isEditTagMode:false
    });
  }

  onClickOptionSelect() {
    if (this.state.selectedBranches.length === 0)
      this.setState({
        snackbarMessage: configJSON.stringsListPage_pleaseSelectStores,
      });
  }

  getBorderSelectDisable() {
    return (
      this.state.selectedBranches.length === 0 ||
      this.state.orderList.length === 0
    );
  }

  getBorderSelectRenderValue(item: unknown) {
    return item && item !== "metal_progetti"
      ? this.getTabList().find(
          ({ apiKey }: { apiKey: string }) => apiKey === item
        )?.label
      : configJSON.stringsListPage_updateOrder;
  }

  getConditionBased(flag: boolean, trueValue: unknown, falseValue: unknown) {
    return flag ? trueValue : falseValue;
  }

  getRenderValueOfReason(item: unknown) {
    let label = this.state.adjustmentList.find(
      (reason: IOption) => reason.id === (item as number)
    )?.label;
    return item ? (label as string) : configJSON.stringsListPage_table_select;
  }

  onChangeAdjustmentComment(value: string) {
    this.setState({ adjustmentComment: value });
  }

  handleSubmitAdjustment(varId: number) {
    const { selectedAdjustmentReason } = this.state;
    if (selectedAdjustmentReason != "") {
      const array = [];
      array.push(varId);
      this.setState(
        { selectedOption: "adjustment", selectedOrders: array },
        () => this.onUpdateAdjustmentOrders()
      );
    } else {
      this.setState({ adjustmentError: true });
    }
  }

  moveToNextPlantStatus(varId: number) {
    const array = [];
    array.push(varId);
    this.setState(
      {
        selectedOption: this.getNextPlantActionTab().apiKey,
        selectedOrders: array,
        isPrintShow: false,
        itemsToPrint: []
      },
      () => this.onUpdateOrders()
    );
  }

  getTableRowColumns() {
    const screenWidth = window.innerWidth;
    const extra = this.state.selectedOption ? "45px" : "";
    const currentTabId = this.getCurrentSelectedTab().tabId;

    const mainBodyConfigs = [
      
      { maxWidth: 1024, config: "150px 150px 150px 210px 100px 100px" },
      { maxWidth: 1280, config: "minmax(180px,1.8fr) 180px 180px 250px 120px 120px" },
      { maxWidth: 1366, config: "minmax(200px,1.8fr) 200px 200px 270px 130px 130px" },
      { maxWidth: Infinity, config: "1fr 1fr 1fr 1fr 1fr 1fr" }
    ];

    const adjustmentTabConfigs = [
      { maxWidth: 1024, config: "150px 100px" },
      { maxWidth: 1280, config: "170px 120px" },
      { maxWidth: 1366, config: "180px 130px" },
      { maxWidth: Infinity, config: "190px 190px" }
    ];

    const sortingTabConfigs = [
      { maxWidth: 1024, config: "150px" },
      { maxWidth: 1280, config: "120px" },
      { maxWidth: 1366, config: "130px" },
      { maxWidth: Infinity, config: "1fr" }
    ];
    //@ts-ignore
    const getConfig = (configs) => configs.find(cfg => screenWidth <= cfg.maxWidth).config;

    const mainBody = getConfig(mainBodyConfigs);
    const isAdjustmentTab = (currentTabId === 6 || currentTabId === 7) ? getConfig(adjustmentTabConfigs) : "";
    const isSortingTab = (currentTabId === 4) ? getConfig(sortingTabConfigs) : "";
    return `${extra} ${mainBody} ${isAdjustmentTab} ${isSortingTab}`.trim();
  }

  handleOpenedChange(open: boolean) {
    this.setState({ isDrawerOpen: open });
  }

  getTableRowClassesForOrderDetails = () => "tableRow" + (this.state.isPrintShow ? " extendedTableRow" : "")

  getTypeOfOrderItemTable(index: number) {
    if (index === 0) return "left";
    else if (index === 6) return "right";
    else return "middle";
  }

  getTypeOfAdjustmentOrderItemTable(index: number) {
    if (index === 0) return "left";
    else if (index === 7) return "right";
    else return "middle";
  }

  getTypeOfOrderTable(index: number) {
    if (
      this.getCurrentSelectedTab().tabId == 7 ||
      this.getCurrentSelectedTab().tabId == 6
    ) {
      return this.getTypeOfAdjustmentOrderItemTable(index);
    } else {
      return this.getTypeOfOrderItemTable(index);
    }
  }

  handlePlantFilterAutoComplete = (title: string, value: string) => {
    this.state.filters.forEach((item: IFilterItem) => {
      if (item.title === title) item.value = value;
      return item;
    });

    let ApiUrl;
    if (title === "Order ID") {
      ApiUrl = `${configJSON.plantOrderFilterSuggestionEndPoint}?status_plant=${this.getCurrentSelectedTab().apiKey}&order_number=`;
    } else if (title === "Customer") {
      ApiUrl = configJSON.plantCustomerFilterSuggestionEndPoint;
    }

    let requestMessage = makeApiMessage({
      url: ApiUrl + value,
      method: "GET",
    });

    if (title === "Order ID") {
      this.filterOrderSuggestionApiCallId = requestMessage.messageId;
    } else if (title === "Customer") {
      this.filterCustomerSuggestionApiCallId = requestMessage.messageId;
    }

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  setFilterSuggestionList(list: { label: string; value: string }[]) {
    const updatedFilters = this.state.filters.map((item: IFilterItem) => {
      if (item.value !== "") {
        if (item.title === this.state.suggestionFieldTitle) item.options = list;
        return item;
      } else {
        if (item.title === this.state.suggestionFieldTitle) item.options = [];
        return item;
      }
    });

    this.setState({ filters: updatedFilters });
  }

  handleFilterOrderSuggestionResp(message: Message) {
    if (
      this.filterOrderSuggestionApiCallId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      const list =
        response?.filter_names?.map(
          (item: { order_number: string | number; id: string | number }) => {
            return {
              label: item.order_number,
              value: item.id,
            };
          }
        ) || [];
      this.setFilterSuggestionList(list);
    }
  }

  handleFilterCustomerSuggestionResp(message: Message) {
    if (
      this.filterCustomerSuggestionApiCallId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      const list =
        response?.filter_names?.map(
          (item: { name: string; id: string | number }) => {
            return {
              label: item.name,
              value: item.id,
            };
          }
        ) || [];
      this.setFilterSuggestionList(list);
    }
  }

  handleCreateNewOrderResp(message: Message) {
    if (
      this.getCreateNewOrderApiCallID ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      {
        const response = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );
        if (response) {
          this.setState(
            {
              adjustmentOrderModal: false,
              editOrderPopupFromAdjustment: true,
              orignalOrderId: this.state.adjustOrder?.id as number,
              adjustOrignleOrder: this.state.adjustOrder,
              adjustmentOrignalOrderNumber: this.state.adjustOrder
                ?.order_number as string,
              adjustOrder: response.data.attributes,
              adjustOrderItems: response.data.attributes.order_items.sort(
                (a: IItemData, b: IItemData) => Number(a.id) - Number(b.id)
              ),
              adjustCartProduct: this.handleAdjustCartProduct(
                response.data.attributes.order_items
              ),
              customerPriceListId: response.data.attributes.price_list_id
            },
            () => this.getStoreManagementBaseOnOrder()
          );
        }
      }
    }
  }

  handleUpdateOrderResp(message: Message) {
    if (
      this.updateOrderApiCallID ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      {
        const response = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );

        if (
          response &&
          !response?.errors &&
          !response?.error
        ) {
          this.setState({
            adjustOrder: response.data.attributes,
            adjustOrderItems: response.data.attributes.order_items.sort(
              (a: IItemData, b: IItemData) => Number(a.id) - Number(b.id)
            ),
            adjustCartProduct: this.handleAdjustCartProduct(
              response.data.attributes.order_items
            ),
          });
        } else if(typeof response?.errors == "string") {
          alert(response.errors);
          // when getting error while adding product into cart then remove cartitem item with id undefined
          const filterAdjustCartProducts = this.state.adjustCartProduct.filter((cartProduct) => cartProduct.id !== undefined)
          this.setState({
            adjustCartProduct: filterAdjustCartProducts,
            cartsItemsPreferencesData: []
          });
        }
        else if(response?.status === 422){
          this.setState({
            snackbarMessage: response.message,
            snackBarSeverity: 'error'
            })
        }
      }
    }
  }

  handleCatalougeListResp(message: Message) {
    if (
      this.getCatalogueListAPICallID ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      {
        const response = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );
        if (response && !response.error) {
          this.setState((prevState) => ({
            cataloguesDataList: this.state.currentPage > 1
            ? [...prevState.cataloguesDataList, ...response.data]
            : [...response.data],
            catalogueListEmptyFlag: response.data.length ? false : true,
            cataloguesListMeta: response.meta,
            isCatalogueCardLoading: false,
          }));
        }
      }
    }
  }

  handlePreferencesListResp(message: Message) {
    if (
      this.getPreferencesDataApiCallId ===
      message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      {
        const response = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );
        if (response) {
          this.setState({
            preferenceData: response.data,
            cartsItemsPreferencesData: [
              ...this.state.cartsItemsPreferencesData,
              {
                catalogue_variant_id:
                  response.data.attributes.catalogue_variant_id,
                catalogue_preference_id: response.data.attributes.id,
                service_id: response.data.attributes.service.id,
              },
            ],
          }, () => this.handleDisanledPopupAPIcall());
        }
      }
    }
  };

  handleDisanledPopupAPIcall = () => {
    const { isPopuDisabledWithOrderCreate } = this.state;
    if(isPopuDisabledWithOrderCreate) {
      this.handleUpdateOrderAPIcall(null)
    }
  };

  handlePlantSectionTab(plantSection: string) {
    const currentTab = this.getTabList().filter(
      (item) => item.apiKey === plantSection
    );
    return currentTab[0].dropId;
  }

  handlePlantUser(plantSection: string) {
    this.setState(
      {
        plantSection: plantSection,
        selectedTab: this.handlePlantSectionTab(plantSection),
      },
      () => {
        this.getOrderList();
      }
    );
  }

  isSelectAllToPrint = () => {
    const {itemsToPrint, orderItems} = this.state
    return itemsToPrint.length > 0 && itemsToPrint.length === orderItems.filter(orderItem => orderItem.attributes.tag_image.length).length
  }

  handleClickPrint(isContinue?: boolean) {
    if (isContinue && this.state.isPrintShow) {
      this.handlePrintTag(this.state.itemsToPrint)
      return;
    }
    this.setState(({ isPrintShow: Boolean(isContinue), itemsToPrint: [] }));
  }

  handleSelectItemToPrint = (orderItem: IOrderItem) => {
    this.setState((prev) => ({itemsToPrint: 
      prev.itemsToPrint.some(printItem => printItem === orderItem) ?
      prev.itemsToPrint.filter(printItem => printItem !== orderItem)
      :
      [...prev.itemsToPrint, orderItem]
    }))
  }

  handleSelectAllItemsToPrint = () => {
    this.setState((prev) => {
      const allTagItems = prev.orderItems.filter(orderItem => orderItem.attributes.tag_image.length)
      return ({
          itemsToPrint: prev.itemsToPrint.length === allTagItems.length ? [] : allTagItems
      })})
  }

  hanldeClickPrintCreditNote = () => {
    const {creditNoteReceipt} = this.state
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_FILE")
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), {
      format: "pdf",
      data: creditNoteReceipt
    })
    this.send(printMessage)
  }

  handleCancelAdjustOrderPopup() {
    this.setState({ adjustMentErrorModal: false });
  }

  handleFilterAnchor(event?: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    this.setState({ 
      filterAnchor: event?.currentTarget 
    }, () => {
      if(this.state.sectionList.length === 0) {
        this.getSectionList();
      }
    });
  }

  handleAutocompleteFilterChange(title: string, value: string) {
    this.setState({ suggestionFieldTitle: title });
    this.handlePlantFilterAutoComplete(title, value);
  }

  handleClearFilter() {
    let updated = this.state.filters.map((item: IFilterItem) => {
      if (item.title === "Date" || item.title === "Data Shared") item.value = null;
      else if (item.title === "Order ID" || item.title === "Customer") {
        item.options = [];
        item.value = "";
      } else item.value = "";
      return item;
    });
    this.setState({
      filters: updated,
      selectedDate: null,
    });
    setTimeout(() => this.handleFilterChange(updated as IFilter[]), 1000);
  }

  getMomentFormat(dateStr: Date | string) {
    return moment(dateStr).format("DD/MM/YYYY");
  }

  hexToRgba = (hex: string | null | undefined, opacity: number): string => {
    if (!hex) return "transparent";
    const cleaned = hex.replace("#", "");
    if (cleaned.length !== 6) return "transparent";
    const r = parseInt(cleaned.substring(0, 2), 16);
    const g = parseInt(cleaned.substring(2, 4), 16);
    const b = parseInt(cleaned.substring(4, 6), 16);
    if ([r, g, b].some((v) => Number.isNaN(v))) return "transparent";
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  getPaymentType(adjustOrder: IlaundryOrder | null) {
    if (!adjustOrder?.order_transactions.length) {
      return '---';
    }
  
    const paymentTypes = adjustOrder.order_transactions
      .map((value) => value.attributes?.payment_method?.payment_type)
      .filter((type) => !!type); 
  
    return paymentTypes.join(',');
  }

  handleOnUserChange(userContext: IUserContext) {
    const apiKey = customPermissionApiKey.plantManagement;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForPlantPermissonStatus(apiKey, userData as Array<PermissionGroupArray>);
console.log(value)
    this.setState({
      userData: userContext?.user as IMyUser,
      palntPermissionStatus: value
    },()=>this.onUserChange());

    const storeId = (userContext.user as IMyUser).attributes.employee_proifle.data.attributes.store_management.store_id as number;

    const storeIds = (userContext.user as IMyUser).attributes.employee_proifle.data.attributes.store_management_ids;

    this.setState({
      tabsId: userContext?.user?.attributes?.employee_proifle?.data?.attributes
        ?.store_management?.attributes?.sections?.[0]?.id as number,
      selectedBranches: storeIds,
      selectAllStoreId: storeIds.length > 0 ? { id: "-1", option: "Select All" } : undefined
    });
  }

  getAdjustmentRequestType() {
    const { adjustmentRequestTypeSub, adjustmentRequestType } = this.state;
    const changeProduct =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.CHANGE_PRODUCT;
    const removeProduct =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.REMOVE_PRODUCT;
    const increaseQuantity =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.ADD_QUANTITY;
    const decreaseQuantity =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.MINUS_QUANTITY;
    const addProduct =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.ADD_NEW_PRODUCT;
    const addUpcharge =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.ADD_UPCHARGE;
    const removeUpcharge =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.REMOVE_UPCHARGE;
    const changeUpcharge =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.CHANGE_UPCHARGE;
    const fullUndone =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.FULL_UNDONE;
    const partialUndone =
      adjustmentRequestTypeSub == this.ADJUSTMENT_TYPES.PARTIAL_UNDONE;
    const cancelOrder =
      this.ADJUSTMENT_TYPES.CANCEL_ORDER == adjustmentRequestType;

    return {
      addProduct,
      fullUndone,
      cancelOrder,
      addUpcharge,
      changeProduct,
      removeProduct,
      partialUndone,
      removeUpcharge,
      changeUpcharge,
      increaseQuantity,
      decreaseQuantity,
    };
  }

  getAdjustEditOrderTitle() {
    const { adjustmentRequestType, adjustmentRequestTypeSub } = this.state;

    if (adjustmentRequestType == this.ADJUSTMENT_TYPES.CANCEL_ORDER)
      return configJSON.editOrderPopup_title_cancel_order;

    switch (adjustmentRequestTypeSub) {
      case this.ADJUSTMENT_TYPES.ADD_QUANTITY:
        return configJSON.editOrderPopup_title_increase_quantity;
      case this.ADJUSTMENT_TYPES.MINUS_QUANTITY:
        return configJSON.editOrderPopup_title_decrease_quantity;
      case this.ADJUSTMENT_TYPES.ADD_NEW_PRODUCT:
        return configJSON.editOrderPopup_title_add_new_product;
      case this.ADJUSTMENT_TYPES.CHANGE_PRODUCT:
        return configJSON.editOrderPopup_title_change_product;
      case this.ADJUSTMENT_TYPES.REMOVE_PRODUCT:
        return configJSON.editOrderPopup_title_remove_product;
      case this.ADJUSTMENT_TYPES.ADD_UPCHARGE:
        return configJSON.editOrderPopup_title_add_upcharge;
      case this.ADJUSTMENT_TYPES.CHANGE_UPCHARGE:
        return configJSON.editOrderPopup_title_edit_upcharge;
      case this.ADJUSTMENT_TYPES.REMOVE_UPCHARGE:
        return configJSON.editOrderPopup_title_remove_upcharge;
      case this.ADJUSTMENT_TYPES.FULL_UNDONE:
        return configJSON.editOrderPopup_title_full_undone;
      case this.ADJUSTMENT_TYPES.PARTIAL_UNDONE:
        return configJSON.editOrderPopup_title_partial_undone;
      default:
        return configJSON.editOrderPopup_title_edit_order;
    }
  }

  getUpChargeButtonTitle() {
    const { addUpcharge, changeUpcharge, removeUpcharge } =
      this.getAdjustmentRequestType();

    if (addUpcharge) return configJSON.editOrderPopup_button_add;
    else if (removeUpcharge) return configJSON.editOrderPopup_button_remove;
    else if (changeUpcharge) return configJSON.editOrderPopup_button_change;
    else return configJSON.editOrderPopup_button_edit;
  }

  handleChangeAdjustmentRequestType(value: string) {
    this.setState({
      adjustmentRequestType: value,
      adjustmentRequestTypeSub: "",
    });
  }

  handleChangeAdjustmentRequestTypeSub(value: string) {
    this.setState({ adjustmentRequestTypeSub: value });
  }

  handleAdjustOrderPopupFlag(flag: boolean) {
    const { adjustmentSelectUpChargeModal } = this.state;
    if (!adjustmentSelectUpChargeModal) {
      this.setState({
        adjustmentRequestType: "",
        adjustmentOrderModal: flag,
        adjustmentRequestTypeSub: "",
      });
    } else {
      this.setState({
        editOrderPopupFromAdjustment: true,
        adjustmentSelectUpChargeModal: false,
      });
    }
  }

  handleCloseReviewOrder() {
    this.setState({
      editOrderPopupFromAdjustment: true,
      reviewOrderPopupFromAdjustment: false,
    });
  }

  handleCloseCancelOrderPopup() {
    this.setState({
      adjustmentCancelOrderMessage: "",
      adjustmentCancelOrderModal: false,
      // editOrderPopupFromAdjustment:false,
    });
  }

  handleCreateNewDummyOrder() {
    const {
      originalAdjustOrderId,
      adjustmentRequestType,
      adjustmentRequestTypeSub,
    } = this.state;
    const body = {
      order_id: originalAdjustOrderId,
      adjustment_reason: adjustmentRequestTypeSub,
      adjustment_request: adjustmentRequestType,
    };
    let message = makeApiMessage({
      url: configJSON.getCreateNewOrderEndpoint,
      body: JSON.stringify(body),
      method: "POST",
    });
    this.getCreateNewOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleContinueAdjustOrder() {
    const { fullUndone, cancelOrder } = this.getAdjustmentRequestType();
    if (fullUndone || cancelOrder) {
      this.setState({
        adjustmentOrderModal: false,
        editOrderPopupFromAdjustment: true,
      });
    } else {
      this.handleCreateNewDummyOrder();
    }
  }

  handleBackEditOrder() {
    const { isB2bMode } = this.state
    const { fullUndone, cancelOrder } = this.getAdjustmentRequestType();
    const condition = fullUndone || cancelOrder;
    const is_redeem_receipt = this.state.orderList.map( (item: IDataItem) => item.attributes?.is_redeem_receipt);

    if (!condition && !isB2bMode && !is_redeem_receipt) {
      this.deleteDummyAdjustOrder(String(this.state.adjustOrder?.id));
    };
     if (is_redeem_receipt) {
      this.golden_point_backup_order(String(this.state.adjustOrder?.id));
    };
    this.setState({
      adjustOrder: this.state.adjustOrignleOrder,
      adjustmentOrderModal: true,
      editOrderPopupFromAdjustment: false,
      adjustRemark: '',
    });
  }

  handleContinueEditOrder() {
    const { fullUndone, cancelOrder } = this.getAdjustmentRequestType();

    if (fullUndone || cancelOrder) {
      const body = cancelOrder
        ? {
            request: "Cancel",
            reason: "Cancel",
          }
        : { request: "Full Undone", reason: "Undone" };

      this.updateAdjustOrder(body);
      this.setState({ editOrderPopupFromAdjustment: false });
    } else {
      if (this.state.isB2bMode) {
        this.handleReviewCreateOrderClick()
      } else {
        this.handleCanceledOrderApiCall();
      } 
    }
  }

  handleChangeItemInEditOrder() {
    this.setState({
      changeProductModal: true,
      editOrderPopupFromAdjustment: false,
    });
  }

  handleBackInChangeItemModal() {
    this.setState({
      changeProductModal: false,
      editOrderPopupFromAdjustment: true,
    });
  }

  handleAddNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ addNote: event.target.value });
  };

  handleAddRemark = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ adjustRemark: event.target.value });
  };

  handleConfirmationCheckBox = () => {
    if (!this.state.creditNotePresent)
      this.setState({
        isConfirmationChecked: !this.state.isConfirmationChecked,
      });
  };

  toggleCreditNoteDialog = (item?: IDataItem) => {
    this.setState({
      creditNoteOrder: item,
      creditNotePresent: false,
      creditNoteReceipt: "",
      isCreditNoteDialogOpen: !this.state.isCreditNoteDialogOpen,
      hidden: true,
    });
    item && this.getCreditNoteApi(item.id);
  };

  getOrderById(varId: string) {
    let message = makeApiMessage({
      url: configJSON.getOrderByIdEndpoint + varId,
      method: "GET",
    });
    this.getAdjustOrderMessageId = message.messageId;
    this.send(message);

    message = makeApiMessage({
      url: configJSON.getOrderItemsByIdEndpoint + varId,
      method: "GET",
    });

    this.getAdjustOrderItemMessageId = message.messageId;
    this.send(message);
  }

  handleAdjustOrderGetApiResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (!response) return;

    if (this.getAdjustOrderMessageId == requestId) {
      this.setState({
        adjustOrder: response.data.attributes,
        adjustOrignleOrder: response.data.attributes
      }, () => {
        this.handleAdjustOrderPopupFlag(true);
      });
    }

    if (this.getAdjustOrderItemMessageId == requestId)
      this.setState({
        adjustOrderItems: response?.data || [],
      });

    if (this.getAdjustmentCancelOrFullUndoneMessageId == requestId) {
      const { adjustOrder, plantSection } = this.state;
      const { fullUndone, cancelOrder } = this.getAdjustmentRequestType();
      const { order_number } = adjustOrder || { order_number: "" };
      const popupMessage = [
        {
          flag: fullUndone || cancelOrder,
          message: String(configJSON.cancelOrderPopup_message_text).replace(
            "$$$",
            order_number
          ),
        },
      ].find((item) => item.flag);

      this.setState({
        adjustmentCancelOrderModal: true,
        adjustmentCancelOrderMessage: popupMessage?.message || "",
      });

      if (plantSection) this.getOrderList(this.getCurrentSelectedTab().apiKey);
      else this.onChangeTabs(5);
    }
  }

  handleClickAdjustOrder(varId: string, orderType: "B2bOrder" | "B2cOrder") {
    const isB2bOrder = orderType === "B2bOrder";
    this.setState({
      originalAdjustOrderId: varId,
      isB2bMode: isB2bOrder
    });
    this.getOrderById(varId);
  }

  handleToggleCartTotal() {
    this.setState((prev) => ({ cartTotalOpen: !prev.cartTotalOpen }));
  }

  getEditOrderPopupConfirmButtonText() {
    const { fullUndone } = this.getAdjustmentRequestType();
    if (fullUndone) return configJSON.editOrderPopup_btn_undone;

    return configJSON.editOrderPopup_btn_continue;
  }

  updateAdjustOrder({ request, reason }: { request: string; reason: string }) {
    const { adjustOrder } = this.state;

    const message = makeApiMessage({
      url: configJSON.cancelOrUndoneAdjustOrderEndpoint,
      method: "PUT",
      body: JSON.stringify({
        remarks: this.state.adjustRemark,
        adjustment_reason: reason,
        adjustment_request: request,
        order_id: adjustOrder?.id,
      }),
    });

    this.getAdjustmentCancelOrFullUndoneMessageId = message.messageId;
    this.send(message);
  }

  getUpdateOrderBody = (params: UpdateOrderBody | null) => {
    const {
      adjustOrder,
      adjustCartProduct,
      cartsItemsPreferencesData,
      selectedService,
      isB2bMode
    } = this.state;

    let preferencesParamsData: {
      specifications: unknown;
      upcharge_list_ids: number[];
    };
    if (params) {
      preferencesParamsData = {
        specifications: params.specifications,
        upcharge_list_ids: params.upcharge_list_ids,
      };
    }

    const customer_Id = sortCondition(
      isB2bMode,
      { business_account_customer_id: adjustOrder?.customer.id },
      { customer_id: adjustOrder?.customer.id }
    ) as {[key in string]: string | number}

    const updateBody = {
      data: {
        ...customer_Id,
        store_management_id: adjustOrder?.store_management_id,
        order_items_attributes: adjustCartProduct
          .filter((item) => item.id === undefined &&
            item.service_id !== -1 &&
            item.service_id == selectedService?.id
          )
          .map((item) => {
            const isCarpetAndFurnitureProduct = item.isCarpetAndFurnitureProduct;

              let carpetAndFurnitureProductBody: 
              { notes: string | undefined; height: number; width: number; weight: number; } | undefined = undefined;
              if(isCarpetAndFurnitureProduct) {
                carpetAndFurnitureProductBody = {
                  notes: item.notes,
                  weight: Number(item.weight),
                  height: Number(item.height),
                  width: Number(item.width),
                }
              } 
            return {
              catalogue_id: item.catalogue_id,
              catalogue_variant_id: item.catalogue_variant_id,
              category_id: item.category_id,
              quantity: item.quantity,
              customer_preference_id: cartsItemsPreferencesData.find(
                (preferenceitem) => {
                  return (
                    preferenceitem.catalogue_variant_id ==
                      item.catalogue_variant_id &&
                    preferenceitem.service_id == item.service_id
                  );
                }
              )?.catalogue_preference_id,
              service_id: item.service_id,
              preference_id: params!== null ? params.preference_id : item.preference_id,
              ...preferencesParamsData,
              ...carpetAndFurnitureProductBody
            };
          }),
      },
    };

    return updateBody;
  };

  handleUpdateOrderAPIcall(params: UpdateOrderBody | null) {
    const { adjustOrder, isB2bMode } = this.state;

    let message = makeApiMessage({
      url: conditionalString(isB2bMode, configJSON.b2bOrderUpdateEndPoint,configJSON.getOrderByIdEndpoint) + adjustOrder?.id,
      body: JSON.stringify(this.getUpdateOrderBody(params)),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  updateQtyApicall(cartItem: IAdjustCartProduct) {
    const { adjustOrder, isB2bMode } = this.state;

    const customer_Id = sortCondition (
      isB2bMode,
      { business_account_customer_id: adjustOrder?.customer.id },
      { customer_id: adjustOrder?.customer.id }
    ) as {[key in string]: string | number}

    const putBody = {
      edit_order: true,
      data: {
        ...customer_Id,
        store_management_id: adjustOrder?.store_management_id,
        order_items_attributes: [
          {
            id: cartItem.id,
            quantity: cartItem.quantity,
            _destroy: cartItem.quantity == 0 ? true : false,
          },
        ],
      },
    };

    let message = makeApiMessage({
      url: conditionalString(isB2bMode, configJSON.b2bOrderUpdateEndPoint, configJSON.getOrderByIdEndpoint) + adjustOrder?.id,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  getCatalogueList = (page: number = this.state.currentPage) => {
    const { tabsId, customerPriceListId, isB2bMode, adjustOrder } = this.state;
    this.setState({isCatalogueCardLoading: true});

    const searchQuery = this.state.searchCatalogue
      ? `&filter_by[query]=${this.state.searchCatalogue}`
      : "";

    const apiEndPoint = sortStringCondition(isB2bMode, configJSON.getB2bCatalogueListApi, configJSON.getCatalogueListApi)

    const customerIdQuery = sortStringCondition(isB2bMode, `&id=${adjustOrder?.customer.id}`, "")

    const apiUrl =
      apiEndPoint +
        `?price_list_id=${customerPriceListId}&category_id=${tabsId}${customerIdQuery}${searchQuery}&per_page=30&page_no=${page}&allow_access=true&pos=true`;

    let message = makeApiMessage({
      url: apiUrl,
      method: "GET",
    });
    this.getCatalogueListAPICallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  getStoreManagementBaseOnOrder = () => {
    const { adjustOrder } = this.state;
    const apiUrl =
      configJSON.getStoreManagementDetails +
      `/${adjustOrder?.store_management_id}?allow_access=true`;

    let message = makeApiMessage({
      url: apiUrl,
      method: "GET",
    });
    this.getStoreManagementDetailsAPICallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  tabSectionChangeHandler = (
    _event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    this.setState({ tabsId: newValue, currentPage: 1 }, () => {
      this.getCatalogueList(1);
    });
  };

  handleAdjustCartProduct(orderItems: IItemData[]) {
    const tempCart = orderItems.map((item) => {
      return {
        id: item.attributes.id,
        catalogue_id: item.attributes.catalogue_id,
        catalogue_variant_id: item.attributes.catalogue_variant_id,
        name: item.attributes.catalogue.name as string,
        product_name: item.attributes.catalogue.product_name,
        product_second_name: item.attributes.catalogue
          .product_second_name as string,
        unit_price: Number(item.attributes.unit_price),
        image: item.attributes.product_image as unknown as string,
        quantity: item.attributes.quantity,
        service_name: item.attributes.service.attributes.name,
        service_id: Number(item.attributes.service.id),
        parent_Product_id: item.attributes.parent_catalogue_id,
        category_id: item.attributes.category_id,
        upcharge_list_ids: item.attributes.upcharge_list_ids,
        preference_id: item.attributes.preference?.attributes.id || 0,
      };
    });

    return tempCart;
  }

  qtyIncreaseHandler = (params: { catalogue: CatalogueDataList }) => {
    const catalogue = params.catalogue;

    if (catalogue.attributes.product_type_id === productTypes.PARENT) {
      this.parentProductClickHandler(catalogue.attributes.id);
      return;
    }

    const { tabsId, adjustCartProduct, clickedParentCatalougeId } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === catalogue.attributes.id &&
        product.category_id === tabsId
    );
    if (selectedProductIndex == -1) {
      const newProductInCart = {
        id: undefined,
        catalogue_id: catalogue.attributes.id,
        catalogue_variant_id:
          catalogue.attributes.catalogue_variants?.data[0].attributes.id,
        name: catalogue.attributes.name,
        product_name: catalogue.attributes.product_name,
        preference_id: catalogue.attributes.preference_id,
        product_second_name: catalogue.attributes.product_second_name,
        unit_price: 0,
        image: catalogue.attributes.catalogue_variants.data[0].attributes.image?.image,
        quantity: 1,
        service_name: "",
        service_id: -1,
        parent_Product_id: clickedParentCatalougeId,
        category_id: tabsId,
        upcharge_list_ids: [],
      };
      tempCartProduct.push(newProductInCart);
    } else {
      const activeServices =
        catalogue.attributes.catalogue_variants.data[0].attributes.catalogue_variants_services.filter(
          (item) => item.service.active
        );
      if (
        tempCartProduct[selectedProductIndex].service_id !== -1 &&
        activeServices.length > 1
      ) {
        this.setState({
          clickedProductCardInfo: tempCartProduct[selectedProductIndex],
          selectedCatalogueData: catalogue
        });
        this.handleSameProductDifferentService();
        return;
      } else if (
        tempCartProduct[selectedProductIndex].service_id !== -1 &&
        activeServices.length == 1
      ) {
        tempCartProduct[selectedProductIndex].quantity =
          tempCartProduct[selectedProductIndex].quantity + 1;
        this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
        return;
      }
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity + 1;
    }
    this.setState({
      adjustCartProduct: tempCartProduct,
    });
  }

  qtyDecreaseHandler = (params: { catalogue: CatalogueDataList }) => {
    const catalogue = params.catalogue;

    if (catalogue.attributes.product_type_id === productTypes.PARENT) {
      this.parentProductClickHandler(catalogue.attributes.id);
      return;
    }
    const { tabsId, adjustCartProduct } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === catalogue.attributes.id &&
        product.category_id === tabsId
    );
    if (tempCartProduct[selectedProductIndex].quantity == 0) {
      return;
    } else {
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity - 1;
      if (tempCartProduct[selectedProductIndex].service_id !== -1) {
        this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
      }
    }
    this.setState({
      adjustCartProduct: tempCartProduct,
    });
  };

  checkForServicesWhenPopupDisabled = (
    clickedCatalougeItem: CatalogueDataList,
    clickedService: ServiceData
  ) => {
    const { tabsId, adjustCartProduct, clickedParentCatalougeId } = this.state;

    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === clickedCatalougeItem.attributes.id &&
        product.service_id === clickedService.id &&
        product.category_id === tabsId
    );
    if (selectedProductIndex == -1) {
      const newProductInCart = {
        id: undefined,
        catalogue_id: clickedCatalougeItem.attributes.id,
        catalogue_variant_id:
          clickedCatalougeItem.attributes.catalogue_variants.data[0].attributes
            .id,
        name: clickedCatalougeItem.attributes.name,
        product_name: clickedCatalougeItem.attributes.product_name,
        product_second_name:
          clickedCatalougeItem.attributes.product_second_name,
        unit_price: 0,
        image:
          clickedCatalougeItem.attributes.catalogue_variants.data[0].attributes
            .image?.image,
        quantity: 1,
        service_name: "",
        service_id: clickedService.id,
        parent_Product_id: clickedParentCatalougeId,
        category_id: tabsId,
        upcharge_list_ids: [],
        preference_id: clickedCatalougeItem.attributes.preference_id,
      };
      tempCartProduct.push(newProductInCart);
      this.setState(
        {
          isPopuDisabledWithOrderCreate: true,
        },
        () => {
          this.getProductPreferencesCall(
            clickedCatalougeItem.attributes.catalogue_variants.data[0].attributes
              .id,
            clickedService.id
          );
        }
      );
      this.setState(
        {
          adjustCartProduct: tempCartProduct,
          isIncreaseBtnClicked: false,
          selectedService: {
            name: clickedService.name,
            id: clickedService.id,
          },
        }
      );
    } else {
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity + 1;
      this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
      this.setState({
        adjustCartProduct: tempCartProduct,
        isIncreaseBtnClicked: false,
        selectedService: {
          name: clickedService.name,
          id: clickedService.id,
        },
      });
    }
    return true;
  };

  handleCheckPreferencesPopup = (
    clickedCatalouge: CatalogueDataList,
    service: ServiceData,
    cartProduct: IAdjustCartProduct
  ) => {
    const { storeManagementDetails, isIncreaseBtnClicked } = this.state;
    const isPreferencesPopupDisabled =
      storeManagementDetails?.data.attributes.store_configuration.attributes
        .item_preference_popup;

    if (!isPreferencesPopupDisabled) {
      if (isIncreaseBtnClicked) {
        this.checkForServicesWhenPopupDisabled(clickedCatalouge, service);
        return true;
      };

      this.setState(
        {
          selectedService: {
            name: service.name,
            id: service.id,
          },
          isPopuDisabledWithOrderCreate: true
        },
        () => {
          this.getProductPreferencesCall(
            clickedCatalouge.attributes.catalogue_variants.data[0].attributes.id,
            service.id
          );
          cartProduct.service_id = service.id;
        }
      );
      return true;
    }
    return false;
  };

  mainServiceHandler = (
    tempCartProduct: IAdjustCartProduct[],
    selectedCatalogueIndex: number,
    catalogue: CatalogueDataList,
    service: ServiceData
  ) => {
    const { isIncreaseBtnClicked } = this.state;
    if (tempCartProduct[selectedCatalogueIndex].service_id !== -1) {
      if (isIncreaseBtnClicked) {
        if (this.checkForServices(catalogue, service)) return 1;
      } else {
        return 1;
      }
    }
  };

  serviceClickHandler = (params: {
    catalogue: CatalogueDataList;
    service: ServiceData;
  }) => {
    const { catalogue, service } = params;
    
    const { tabsId, adjustCartProduct } = this.state;

    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === catalogue.attributes.id &&
        product.category_id === tabsId
    );
    if (selectedProductIndex < 0) {
      return;
    } else {

      // if product measurement is SQM or weight then display popup
      const carpetFurnitureMeasurementTypes = ["SQM", "Weight"];
      let isCarpetFurnitureProductType = catalogue.attributes.catalogue_variants.data[0].attributes?.measurement_type?.some(type => carpetFurnitureMeasurementTypes.includes(type) );
      
      if(isCarpetFurnitureProductType) {
        this.getProductPreferencesCall(
          catalogue.attributes.catalogue_variants.data[0].attributes.id,
            service.id
        );
        this.setState({
          productPopup: true,
          carpetFurnitureProductPopupData: catalogue,
          selectedService: {
            name: service.name,
            id: service.id,
          },
        });
        return;
      }

      if (
        this.handleCheckPreferencesPopup(
          catalogue,
          service,
          tempCartProduct[selectedProductIndex]
        )
      ) {
        return;
      }

      const value = this.mainServiceHandler(
        tempCartProduct,
        selectedProductIndex,
        catalogue,
        service
      );
      if (value === 1) {
        return;
      }
      tempCartProduct[selectedProductIndex].service_id = service.id;
    }

    this.getProductPreferencesCall(
      catalogue.attributes.catalogue_variants.data[0].attributes.id,
      service.id
    );

    this.setState({
      selectedService: {
        name: service.name,
        id: service.id,
      },
      adjustCartProduct: tempCartProduct,
      preferenceModalVisible: true,
    });
  }

  checkForServices = (
    clickedCatalouge: CatalogueDataList,
    clickedService: ServiceData
  ) => {
    const { tabsId, adjustCartProduct, clickedParentCatalougeId } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === clickedCatalouge.attributes.id &&
        product.category_id === tabsId &&
        product.service_id === clickedService.id
    );
    if (selectedProductIndex == -1) {
      const newProductInCart = {
        id: undefined,
        catalogue_id: clickedCatalouge.attributes.id,
        catalogue_variant_id:
          clickedCatalouge.attributes.catalogue_variants.data[0].attributes.id,
        name: clickedCatalouge.attributes.name,
        product_name: clickedCatalouge.attributes.product_name,
        product_second_name: clickedCatalouge.attributes.product_second_name,
        unit_price: 0,
        image: 
          clickedCatalouge.attributes.catalogue_variants.data[0].attributes.image?.image,
        quantity: 1,
        service_name: "",
        service_id: clickedService.id,
        parent_Product_id: clickedParentCatalougeId,
        category_id: tabsId,
        upcharge_list_ids: [],
        preference_id: clickedCatalouge.attributes.preference_id,
      };
      tempCartProduct.push(newProductInCart);
      this.getProductPreferencesCall(
        clickedCatalouge.attributes.catalogue_variants.data[0].attributes.id,
        clickedService.id
      );
      this.setState({
        adjustCartProduct: tempCartProduct,
        isIncreaseBtnClicked: false,
        selectedService: {
          name: clickedService.name,
          id: clickedService.id,
        },
        preferenceModalVisible: true,
      });
    } else {
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity + 1;
      this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
      this.setState({
        adjustCartProduct: tempCartProduct,
        isIncreaseBtnClicked: false,
        selectedService: {
          name: clickedService.name,
          id: clickedService.id,
        },
      });
    }
    return true;
  };


  getProductPreferencesCall = (
    catalogue_variant_id: number,
    service_id: number
  ) => {
    const { adjustOrder } = this.state;

    const apiUrl =
      configJSON.getProductPreferences +
      `?customer_id=${adjustOrder?.customer.id}&catalogue_variant_id=${catalogue_variant_id}&service_id=${service_id}&allow_access=true&store_id=${adjustOrder?.store_management_id}`;

    let message = makeApiMessage({
      url: apiUrl,
      method: "GET",
    });
    this.getPreferencesDataApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleClosePreference = () => {
    this.setState({ preferenceModalVisible: false });
    this.handleUpdateOrderAPIcall(null);
  };

  handleCartOnCarpetAndFunrnitureProduct = async (carpetFurniturebodyParams: IFormValues[]) => {
    const { tabsId, adjustCartProduct, selectedService } = this.state;
    const productPopupData = this.state.carpetFurnitureProductPopupData as CatalogueDataList;
    const tempCartProduct = [...adjustCartProduct];
    carpetFurniturebodyParams.forEach((param) => {
      const newProductInCart = {
        id: undefined,
        catalogue_id: productPopupData.attributes.id || 0,
        catalogue_variant_id:
          productPopupData.attributes.catalogue_variants?.data[0].attributes.id || 0,
        name: productPopupData.attributes.name,
        product_name: productPopupData?.attributes.product_name,
        product_second_name: productPopupData?.attributes.product_second_name,
        unit_price: 0,
        image: 
          productPopupData?.attributes.catalogue_variants.data[0].attributes.image
            .image,
        quantity: param.quantity,
        service_name: selectedService?.name || "",
        service_id: selectedService?.id || -1,
        parent_Product_id: this.state.clickedParentCatalougeId,
        category_id: tabsId,
        upcharge_list_ids: [],
        preference_id: productPopupData.attributes.preference_id,
        isCarpetAndFurnitureProduct: true,
        notes: param.notes,
        height: Number(param.height),
        width: Number(param.width),
        weight: Number(param.weight),
      };
      tempCartProduct.push(newProductInCart);
    });

    const filterCartProducts = tempCartProduct.filter((product) => product.service_id !== -1);
    this.setState({
      adjustCartProduct: filterCartProducts,
    });
  }

  async handleSubmitCarpetAndFunrnitureProduct(items: IFormValues[]) {
    const filteredItems = items.map((item) => {
      if (item.isNew) item.id = undefined
      return item
    })
    await this.handleCartOnCarpetAndFunrnitureProduct(filteredItems)
    if (this.state.adjustOrder?.id) {
      this.handleUpdateOrderAPIcall(null);
    } 

    this.setState({
      subProductModal: false,
      clickedParentCatalougeId: null,
      productPopup: false, 
      carpetFurnitureProductPopupData: null
    })
  }

  onCloseCareptAndFurnitureProductPopup = () => {
    this.setState({productPopup: false, carpetFurnitureProductPopupData: null})
  }

  handleCreateAdjustOrderPreference = (data: CreatePreferencesData) => {
    this.setState({
      preferenceModalVisible: false
    });
    const { adjustOrder, preferenceData, isB2bMode } = this.state;

    const selectedSpecifications = data.selectedOptions
      ?.filter((element) => element.option_id)
      .map((item) => ({
        specification_option_id: Number(item.option_id),
      }));

      
    const customer_Id = sortCondition(
      isB2bMode,
      { business_account_customer_id: adjustOrder?.customer.id },
      { customer_id: adjustOrder?.customer.id }
    ) as {[key in string]: string | number}

    const bodyData = {
      data: {
        attributes: {
          ...customer_Id,
          preferences_attributes: [
            {
              id: Number((preferenceData as IpreferenceData).attributes?.id),
              catalogue_variant_id: Number(data.id),
              preference_id: data.preferenceId,
              upcharge_list_ids: data.upchargeListIds,
              service_id: data.serviceId,
              notes: data.notes,
              save_for_future: data.saveForFuture,
              pref_spec_options_attributes: selectedSpecifications,
            },
          ],
        },
      },
    };

    if (adjustOrder?.id) {
      const spesificationList: IadjustSpecification[] =
        (preferenceData as IpreferenceData).attributes?.specifications ?? [];

      const spesificationData: { [key: string]: string | undefined } = {};

      selectedSpecifications.forEach((element) => {
        const optionId = element.specification_option_id;
        const spesification = spesificationList.find((elem) =>
          elem.options_attributes.map((elem2) => elem2.id).includes(optionId)
        );
        if (spesification) {
          spesificationData[spesification.name] =
            spesification.options_attributes.find(
              (element) => element.id === optionId
            )?.label;
        }
      });

      const updateOrderData = {
        specifications: spesificationData,
        preference_id: data.preferenceId,
        upcharge_list_ids: data.upchargeListIds,
        catalogue_variant_id: Number(data.id),
      };

      this.handleUpdateOrderAPIcall(updateOrderData);
    }

    let message = makeApiMessage({
      url: configJSON.createPreferenceApiEndPoint,
      body: JSON.stringify(bodyData),
      method: "PUT",
    });
    this.createPreferencesApicallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  qtyHandlerInCart = (data: IItemData, actionKey: string) => {
    const { adjustCartProduct } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.id === Number(data.attributes.id)
    );
    if (actionKey === "plus") {
      tempCartProduct[selectedProductIndex].quantity =
        tempCartProduct[selectedProductIndex].quantity + 1;
      this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
    } else {
      if (tempCartProduct[selectedProductIndex].quantity == 0) {
        return;
      } else {
        tempCartProduct[selectedProductIndex].quantity =
          tempCartProduct[selectedProductIndex].quantity - 1;
        this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
      }
    }
    this.setState({
      adjustCartProduct: tempCartProduct,
    });
  };

  getUpchargeListForProduct() {
    this.setState({
      adjustmentSelectUpChargeModal: true
    });
  }

  handleToggleUpchargeTick(itemId: string, upchargeId: number) {
    const list = this.state.orderUpChargePreference.map(
      (item: ICustomerSpecs) => {
        if (item.id == itemId) {
          const list = item.attributes.upcharge_lists.map(
            (upcharge: IUpChargeItem) => {
              if (upcharge.id == upchargeId) {
                upcharge.checked = !upcharge.checked;
                upcharge.isUpdated = true;
              }
              return upcharge;
            }
          );
          item.attributes.upcharge_lists = list;
        }
        return item;
      }
    );

    this.setState({ orderUpChargePreference: list });
  }

  handleCloseUpchargePopup() {
    this.setState({
      editOrderPopupFromAdjustment: true,
      adjustmentSelectUpChargeModal: false,
    });
  }

  updateOrderForUpChargesApi(body: unknown) {
    const message = makeApiMessage({
      url: configJSON.updateOrderEndPoint + this.state.adjustOrder?.id,
      method: "PUT",
      body: JSON.stringify(body as {}),
    });
    this.getUpdateOrderMessageId = message.messageId;
    this.send(message);
  }

  handleUpChargeOrder(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId != this.getUpdateOrderMessageId || !response) return;

    this.getOrderById(response.data.id);
    this.getOrderItemsList(response.data.id);
  }

handleScanOrderResponse(message: Message) {
  const requestId = message.getData(
    getName(MessageEnum.RestAPIResponceDataMessage)
  );
  const response = message.getData(
    getName(MessageEnum.RestAPIResponceSuccessMessage)
  );
  if (requestId !== this.scanOrderApiCallId) return;

  this.setState({ isScanningOrder: false });

  if (response?.errors) {
    this.setState({ snackbarMessage: response.errors });
    return;
  }

  const order = response?.data;
  if (!order?.attributes) return;
  if (order.attributes.is_quick_drop) {
    this.setState({ snackbarMessage: "This is a quick drop order" });
    return;
  }

  if (this.state.selectedTab === 6) {
    this.onOpenOrderDetails(order);
    return;
  }
  const currentSection =
    this.state.plantSection || this.getCurrentSelectedTab().apiKey;

  if (order.attributes.status_plant !== currentSection) {
    this.setState({
      snackbarMessage: "This order does not belong to the current section",
    });
    return;
  }

  const isReceivingAreaOrder =
    order.attributes.status_plant === "receiving_area";

  this.shouldPrintTag = isReceivingAreaOrder;

  if (this.state.orderData?.attributes.status_plant === "receiving_area") {
    this.moveToShortingAreaByScanning(this.state.orderData, order);
  } else {
    this.onOpenOrderDetails(order);
  }
}


handleLinkPermanentTagResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId !== this.linkPermanentTagApiCallId) return;

    this.setState({ isLinkingPermanentTag: false });

    if (response && !response.errors) {
      const { currentMapTagIndex, orderItems } = this.state;

      // Update the editableTagValues with the newly linked tag code
      const currentItem = orderItems[currentMapTagIndex];
      const tagCode = response.data?.attributes?.permanent_tag?.tag_code || "";

      // Find the next unmapped item (starting from currentMapTagIndex + 1)
      let nextUnmappedIndex = -1;
      for (let i = currentMapTagIndex + 1; i < orderItems.length; i++) {
        if (!orderItems[i].attributes.order_item_tags?.[0]?.permanent_tag?.tag_code) {
          nextUnmappedIndex = i;
          break;
        }
      }

      const newIndex = nextUnmappedIndex >= 0 ? nextUnmappedIndex : orderItems.length;

      // Set pending scroll index - will be executed after order items refresh
      this.pendingScrollIndex = newIndex;

      this.setState((prevState) => ({
        currentMapTagIndex: newIndex,
        editableTagValues: {
          ...prevState.editableTagValues,
          [`${currentItem.id}${currentMapTagIndex}`]: tagCode
        },
        snackbarMessage: `Tag linked successfully for item ${currentMapTagIndex + 1}`,
        snackBarSeverity: 'success'
      }));

      // Refresh the order items to get updated data
      if (this.state.orderData) {
        this.getOrderItemsList(String(this.state.orderData.attributes.id));
      }
    } else {
      const errorMessage = response?.errors?.[0]?.message || response?.errors?.[0] || "Failed to link permanent tag";
      this.setState({
        snackbarMessage: errorMessage,
        snackBarSeverity: 'error'
      });
    }
  }

  scrollToOrderItem = (index: number) => {
    // Use setTimeout to ensure DOM is fully updated before scrolling
    setTimeout(() => {
      const rowElement = this.orderItemRowRefs.get(index);
      if (rowElement) {
        rowElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 100);
  }

  setOrderItemRowRef = (index: number, element: HTMLDivElement | null) => {
    this.orderItemRowRefs.set(index, element);
  }

  handleUnlinkPermanentTagResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId !== this.unlinkPermanentTagApiCallId) return;

    this.setState({ isLinkingPermanentTag: false });

    if (response && !response.errors) {
      // Set flag to recalculate the first unmapped index after order items refresh
      this.shouldRecalculateMapIndex = true;

      this.setState({
        snackbarMessage: "Permanent tag unlinked successfully",
        snackBarSeverity: 'success'
      });

      // Refresh the order items to get updated data
      if (this.state.orderData) {
        this.getOrderItemsList(String(this.state.orderData.attributes.id));
      }
    } else {
      const errorMessage = response?.errors?.[0]?.message || response?.errors?.[0] || "Failed to unlink permanent tag";
      this.setState({
        snackbarMessage: errorMessage,
        snackBarSeverity: 'error'
      });
    }
  }

  handleGetSharedFolderDataResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId !== this.getSharedFolderMessageId) return;
    let errorMessage = "";
    if (response?.data?.length) {
      const inputFiles = response.data as {file_name: string; file_content: string; share_folders: string[]}[]
      const payload = inputFiles.flatMap(inputFile => 
        inputFile.share_folders.map(sharedFolder => ({
          file_path: sharedFolder + "\\" + inputFile.file_name,
          file_content: inputFile.file_content
        })))
      this.writeFiles(payload)
    } else {
      errorMessage = "No input file available for the orders"
    }
    this.setState((prev) => ({
      isLoadingSharedFolder: false, 
      selectedOption: "", selectedOrders: [], 
      snackbarMessage: errorMessage, 
      snackBarSeverity: errorMessage ? "error" : prev.snackBarSeverity
    }))
    this.getOrderList(this.getCurrentSelectedTab().apiKey);
  }

  handleGetFilesForAutoSendResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId !== this.getFilesForAutoSendMessageId) return;
    if (response?.data?.length) {
      const inputFiles = response.data as {file_name: string; file_content: string; share_folders: string[]}[]
      const payload = inputFiles.flatMap(inputFile => 
        inputFile.share_folders.map(sharedFolder => ({
          file_path: sharedFolder + "\\" + inputFile.file_name,
          file_content: inputFile.file_content
        })))
      this.writeFiles(payload, true, response.is_more)
    } else {
      this.disableGetFiles = false
      this.getOrderList(this.getCurrentSelectedTab().apiKey)
    }
  }

  updatePreferenceForUpChargesApi(body: unknown) {
    const message = makeApiMessage({
      method: "PUT",
      body: JSON.stringify(body as {}),
      url: configJSON.updateCustomerPreferenceEndpoint,
    });
    this.getUpdateUpChargePreferenceMessageId = message.messageId;
    this.send(message);
  }

  handleUpChargeForPreference(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId != this.getUpdateUpChargePreferenceMessageId || !response)
      return;
  }

  handleDropdownUpChargeChange(varIds: number[], varId: string) {
    const { orderUpChargePreference } = this.state;

    const list = orderUpChargePreference.map((item) => {
      if (item.id == varId) {
        const list = item?.attributes?.upcharge_lists;
        const modifiedList = list.slice(6).map((item) => {
          item.checked = varIds.includes(item.id);
          return item;
        });
        const finalArray = [...list.slice(0, 6), ...modifiedList];
        item.attributes.upcharge_lists = finalArray;
      }
      return item;
    });

    this.setState({ orderUpChargePreference: list });
  }

  handleSameProductDifferentService = () => {
    this.setState({ sameProductDifferentServiceModalOpen: true });
  };

  sameProductDiffServiceModalClose = () => {
    // if product measurement is SQM and weight type then display carpet and funiture popup again don't increase quantity
    const carpetFurnitureMeasurementTypes = ["SQM", "Weight"];
    let isCarpetFurnitureProductType = this.state.selectedCatalogueData?.attributes.catalogue_variants.data[0].attributes?.measurement_type?.some(type => carpetFurnitureMeasurementTypes.includes(type) );
    
    if(isCarpetFurnitureProductType) {
      this.setState({
        productPopup: true,
        carpetFurnitureProductPopupData: this.state.selectedCatalogueData,
        sameProductDifferentServiceModalOpen: false,
        clickedProductCardInfo: null,
      });
      return;
    }
    const { adjustCartProduct, clickedProductCardInfo, tabsId } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (item) =>
        item.catalogue_id === clickedProductCardInfo?.catalogue_id &&
        item.category_id === tabsId &&
        item.service_id === clickedProductCardInfo.service_id
    );
    tempCartProduct[selectedProductIndex].quantity =
      tempCartProduct[selectedProductIndex].quantity + 1;
    this.updateQtyApicall(tempCartProduct[selectedProductIndex]);
    this.setState({
      sameProductDifferentServiceModalOpen: false,
      adjustCartProduct: tempCartProduct,
    });
  };

  sameProductDiffServiceConfirmClick = () => {
    this.setState({
      sameProductDifferentServiceModalOpen: false,
      isIncreaseBtnClicked: true,
    });
  };

  handleTogglePreferenceTick(itemId: string, preferenceId: number) {
    const list = this.state.orderUpChargePreference.map(
      (item: ICustomerSpecs) => {
        if (item.id == itemId) {
          item.attributes.preferences = item.attributes.preferences.map(
            (preference: IPreference) => {
              if (preference.id == preferenceId)
                preference.checked = !preference.checked;
              else preference.checked = false;
              return preference;
            }
          );
        }
        return item;
      }
    );

    this.setState({ orderUpChargePreference: list });
  }

  handleToggleSpecificationTick(
    itemId: string,
    specsId: number,
    optionId: number
  ) {
    const list = this.state.orderUpChargePreference.map(
      (item: ICustomerSpecs) => {
        if (item.id == itemId) {
          const list = item.attributes.specifications.map(
            (item: ISpecification) => {
              if (item.id == specsId) {
                item.options_attributes = item.options_attributes.map(
                  (item: ISpecOption) => {
                    item.selected = item.id == optionId;
                    return item;
                  }
                );
              }
              return item;
            }
          );
          item.attributes.specifications = list;
        }
        return item;
      }
    );

    this.setState({ orderUpChargePreference: list });
  }

  handleCanceledOrderApiCall() {
    const { adjustOrder } = this.state;

    const message = makeApiMessage({
      method: "GET",
      url: configJSON.checkCanceledOrderEndPoint + adjustOrder?.id,
    });
    this.checkForOrderCanceledMessageId = message.messageId;
    this.send(message);
  }

  handleReviewCreateOrderClick() {
    const message = makeApiMessage({
      method: "POST",
      url: conditionalString(
        this.state.isB2bMode,
        configJSON.confirmAdjustB2BOrderEndPoint,
        configJSON.confirmAdjustOrderEndPoint,
      ),
      body: JSON.stringify({
        order_id: this.state.adjustOrder?.id,
        remarks: this.state.adjustRemark
      }),
    });
    this.adjustOrderConfirmMessageId = message.messageId;
    this.send(message);
  }

  handleConfirmOrderResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId == this.adjustOrderConfirmMessageId) {
      if(response && !response.errors) {
        this.setState({
          reviewOrderPopupFromAdjustment: false,
          editOrderPopupFromAdjustment: false,
          adjustRemark: "",
          snackbarMessage: response.message, 
          snackBarSeverity: "success"
        });
        
        if (this.state.plantSection)
          this.getOrderList(this.getCurrentSelectedTab().apiKey);
        else this.onChangeTabs(5);
      } else {
        this.setState({
          snackbarMessage: response.errors, 
          snackBarSeverity: "error" 
        })
      }
    }
  }

  handleCheckCanceledOrderResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId == this.checkForOrderCanceledMessageId && response) {
      if (response.cancel_order) {
        const order_number = this.state.adjustmentOrignalOrderNumber;
        const is_redeem_receipt = this.state.orderList.map( (item: IDataItem) => item.attributes?.is_redeem_receipt);
        let popupMessage = "";

        if (is_redeem_receipt) {
          popupMessage = String(
            configJSON.golden_point_order_adjust
          ).replace("$$$", order_number);
           this.setState({
          adjustmentCancelOrderMessage:
            popupMessage 
        });
        } else {
          popupMessage = String(
            configJSON.cancelOrderPopup_message_text
          ).replace("$$$", order_number);
           this.setState({
          adjustmentCancelOrderMessage:
            popupMessage + configJSON.cancelOrderPopup_message_text2,
          adjustmentCancelOrderModal: true,
        });
        }
      }
      this.handleReviewCreateOrderClick()
    }
  }

  getEnableDisableForAdjustOrder() {
    const { adjustmentRequestType, adjustmentRequestTypeSub } = this.state;

    if (adjustmentRequestType == "Cancel") return true;
    else if (!adjustmentRequestType || !adjustmentRequestTypeSub) return false;
    else return true;
  }

  createCreditNoteApi() {
    const { addNote, creditNoteOrder } = this.state;
    this.setState({creditLoader:true})
    const message = makeApiMessage({
      url: configJSON.createCreditNoteEndPoint,
      method: "POST",
      body: JSON.stringify({
        notes: addNote,
        order_id: creditNoteOrder?.id,
      }),
    });
    this.getCreateCreditNoteMessageId = message.messageId;
    this.send(message);
  }

  getCreditNoteApi(orderId?: string) {
    this.setState({
      openCrediNoteModalLoader: true,
    });
    const message = makeApiMessage({
      url: configJSON.getCreditNoteEndpoint + orderId,
      method: "GET",
    });
    this.getCreditNoteMessageId = message.messageId;
    this.send(message);
  }

  handleCreditNoteResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId == this.getCreateCreditNoteMessageId && response) {
      if(response?.errors?.length) {
        this.setState({
          creditLoader: false,
        })
        alert(response.errors)
      } else {
        this.setState({
          snackbarMessage: "Credit note created successfully.",
          snackBarSeverity: "success",
          creditLoader:false,
          creditNoteOrder: undefined,
          isCreditNoteDialogOpen: false,
        });
        this.getOrderList(this.getCurrentSelectedTab().apiKey);
      }
    } else if (requestId == this.getCreditNoteMessageId && response?.data) {
      const note = response.data.attributes?.notes || "";
      this.setState({
        addNote: note,
        creditNoteOrderNumber: response.data.attributes.order_number,
        creditNotePresent: true,
        creditNoteReceipt:  toString(response.data.attributes.credit_note_receipt),
        openCrediNoteModalLoader: false
      });
    } 
    
    if (requestId == this.getCreditNoteMessageId && response?.errors) {
      this.setState({ hidden: false, openCrediNoteModalLoader: false });
    }
  }

  handleStoreManagementDetailsResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId == this.getStoreManagementDetailsAPICallID) {
      this.setState(
        {
          storeManagementDetails: response,
          tabsId:
            response.data.attributes.store_configuration.attributes.sections[0]
              .id,
          currentPage: 1
        },
        () => this.getCatalogueList(1)
      );
    }
  }

  getCombinationList() {
    const { adjustOrderItems } = this.state;
    const newArry = Array.from(
      new Set(
        adjustOrderItems.map((item) => {
          return {
            service_id: Number(item.attributes.service.id),
            category_id: item.attributes.category_id,
          };
        })
      )
    );
    return newArry;
  }

  getUniqueCombinationList(combinationList: UniqueCombination[]) {
    const newArray = combinationList.filter(
      (filterEle, index) =>
        index ===
        combinationList.findIndex(
          (element) =>
            element.category_id === filterEle.category_id &&
            element.service_id === filterEle.service_id
        )
    );
    return newArray;
  }

  findItemFromUnique(uniqueItem: UniqueCombination) {
    const { adjustOrderItems } = this.state;

    const uniqueSingleItem = adjustOrderItems?.find(
      (item: IItemData) =>
        Number(item.attributes.service.id) == uniqueItem.service_id &&
        item.attributes.category_id === uniqueItem.category_id
    );

    return uniqueSingleItem;
  }

  findSubItemsList(uniqueItem: UniqueCombination) {
    const { adjustOrderItems } = this.state;

    const subItemList = adjustOrderItems?.filter(
      (item: IItemData) =>
        Number(item.attributes.service.id) == uniqueItem.service_id &&
        item.attributes.category_id === uniqueItem.category_id
    );

    return subItemList;
  }

  deleteOrderItemHandler(data: IItemData) {
    const { adjustCartProduct } = this.state;
    const tempCartProduct = [...adjustCartProduct];
    const selectedProductIndex = tempCartProduct.findIndex(
      (product) =>
        product.catalogue_id === data.attributes.catalogue_id &&
        product.service_id === Number(data.attributes.service.id)
    );
    this.deleteOrderItemApicall(tempCartProduct[selectedProductIndex]);
  }

  deleteOrderItemApicall(cartItem: IAdjustCartProduct) {
    const { adjustOrder, isB2bMode } = this.state;
    
    const customer_Id = sortCondition(
      isB2bMode,
      { business_account_customer_id: adjustOrder?.customer.id },
      { customer_id: adjustOrder?.customer.id }
    ) as {[key in string]: string | number}

    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: adjustOrder?.store_management_id,
        order_items_attributes: [
          {
            id: cartItem.id,
            _destroy: true,
          },
        ],
      },
    };

    let message = makeApiMessage({
      url: conditionalString(isB2bMode, configJSON.b2bOrderUpdateEndPoint, configJSON.getOrderByIdEndpoint) + adjustOrder?.id,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  parentProductClickHandler = (catalogueId: number) => {
    this.setState({
      subProductModal: true,
      clickedParentCatalougeId: catalogueId,
    });
  };

  subProductPopupModalHandler = () => { this.setState({subProductModal: false })};

  handleCall = () => {
    this.sendOrderToClean("oe");
    this.subProductPopupModalHandler();
    this.scanOrder("");
    this.setState({subProductModal: false})
  }

  handleStatusScroll = (isDrawerOpen: boolean) => {
    const width = window.innerWidth;
    if (width <= 1366 || (width <= 1560 && isDrawerOpen)) {
        return 'scrollable';
    } else {
        return 'fullWidth';
    }
  };

  handleNoTagsOrdersItems = (orderItems: IOrderItem[]) => {
    const newArray = orderItems.flatMap((Iorder) => {
      if(Iorder.attributes.tag_numbers.length > 0) {
        return Iorder.attributes.tag_numbers.map((tagNum) => ({
          ...Iorder,
          attributes: {
            ...Iorder.attributes,
            tag_numbers: [tagNum],
            tag_image: Iorder.attributes.tag_image?.filter(image => image.tag_no === tagNum) || [],
            order_item_tags: Iorder.attributes.order_item_tags?.filter(
              tag => Number(tag.tag_number) === Number(tagNum)
            ) || []
          },
        }));
      } else {
        return Iorder;
      }
    });
    return newArray;
  };

  handleSearchCatalogue = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({currentPage: 1, searchCatalogue: event.target.value as string},
      () => this.getCatalogueList()
    )
  }

  handleCatalogueListScroll = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLElement;
    const position = target.scrollTop + target.clientHeight;
    if (
      !this.state.isCatalogueCardLoading &&
      target.scrollHeight - position <= 1.3 &&
      !this.state.catalogueListEmptyFlag
    ) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () =>
        this.getCatalogueList(this.state.currentPage)
      );
    }
  };
  scanOrder = (orderNumber: string) => {
    // Check if in edit tag mode and scanned value is a tag code (less than 10 characters)
    if (this.state.isEditTagMode && orderNumber && orderNumber.length < 10) {
      this.linkPermanentTag(orderNumber);
      return;
    }

    if (
      orderNumber && this.state.orderData?.attributes.order_number === orderNumber
    ) {
      if (this.isShowNextLabel()) {
        this.moveToNextPlantStatus(this.state.orderData.attributes.id)
      }
      return;
    }
    const endPoint = configJSON.getOrderByIdEndpoint + `${encodeURIComponent(orderNumber)}?for_barcode=true`
    this.setState({isScanningOrder: true})
    const message = makeApiMessage({
      method: "GET",
      url: endPoint
    });
    this.scanOrderApiCallId = message.messageId
    this.send(message)
  }

  linkPermanentTag = (tagCode: string) => {
    const { orderItems, currentMapTagIndex } = this.state;

    // Check if there are items to map
    if (currentMapTagIndex >= orderItems.length) {
      this.setState({ snackbarMessage: "All items have been mapped", snackBarSeverity: 'success' });
      return;
    }

    const currentItem = orderItems[currentMapTagIndex];

    // Skip if this item is already mapped
    if (currentItem.attributes.order_item_tags?.[0]?.permanent_tag?.tag_code) {
      // Find next unmapped item
      let nextUnmappedIndex = -1;
      for (let i = currentMapTagIndex + 1; i < orderItems.length; i++) {
        if (!orderItems[i].attributes.order_item_tags?.[0]?.permanent_tag?.tag_code) {
          nextUnmappedIndex = i;
          break;
        }
      }
      if (nextUnmappedIndex >= 0) {
        this.setState({ currentMapTagIndex: nextUnmappedIndex }, () => {
          this.linkPermanentTag(tagCode);
        });
      } else {
        this.setState({ snackbarMessage: "All items have been mapped", snackBarSeverity: 'success' });
      }
      return;
    }

    const orderItemTagId = currentItem.attributes.order_item_tags?.[0]?.id;

    if (!orderItemTagId) {
      this.setState({ snackbarMessage: "No order item tag found for this item" });
      return;
    }

    const endPoint = `bx_block_order_management/order_item_tags/${orderItemTagId}/link_permanent_tag`;

    this.setState({ isLinkingPermanentTag: true });

    const message = makeApiMessage({
      method: "POST",
      url: endPoint,
      body: JSON.stringify({ tag_code: tagCode })
    });

    this.linkPermanentTagApiCallId = message.messageId;
    this.send(message);
  }

  unlinkPermanentTag = (orderItemTagId: number) => {
    const endPoint = `bx_block_order_management/order_item_tags/${orderItemTagId}/unlink_permanent_tag`;

    this.setState({ isLinkingPermanentTag: true });

    const message = makeApiMessage({
      method: "DELETE",
      url: endPoint
    });

    this.unlinkPermanentTagApiCallId = message.messageId;
    this.send(message);
  }

scanGarmentTag = (orderNumber: string) => {
  console.log("scanGarmentTag", orderNumber,this.state.storeManagementDetails);

  if (
    orderNumber && this.state.orderData?.attributes.order_number === orderNumber
  ) {
    if (this.isShowNextLabel()) {
      this.moveToNextPlantStatus(this.state.orderData.attributes.id);
    }
    return;
  }
  let endPoint = configJSON.getOrderByIdEndpoint + `${encodeURIComponent(orderNumber)}?for_barcode=true`;

  if (this.state.selectedTab === 6) {
    endPoint += "&isScanGarmentTag=true";
  }

  this.setState({ isScanningOrder: true });

  const message = makeApiMessage({
    method: "GET",
    url: endPoint
  });

  this.scanOrderApiCallId = message.messageId;
  this.send(message);
}



  handlePrintTag = (items: IOrderItem[]) => {
    const tags = items.flatMap(item => item.attributes.tag_image.map(image => image.label_string))
    const tagsToPrint = tags.filter(Boolean)
    if (tagsToPrint.length) {
      const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_TAGS")
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), tagsToPrint)
      this.send(printMessage)
    }
  }

  printIconClasses = (isDisabled: boolean) => "printIcon" + (isDisabled ? " disabled": "")

  handleCloseEditPreferencesPopup = () => {
    this.setState({
      adjustmentSelectUpChargeModal: false,
    });
  };

  getSpecificatonBodyObj = (specificationList: EditSpecificationType) => {
    const transformedObject = Object.keys(specificationList).reduce(
      (
        accVal: {
          [key: string]: string[];
        },
        keyVal
      ) => {
        const options = specificationList[keyVal].map(item => item.option);
        if (options.length > 0) {
          accVal[keyVal] = options;
        }
        return accVal;
      },
      {}
    );

    return transformedObject;
  };

  getUpdatePreferenceBody = (
    updatedPreferencesData: SelectedPreferenceData[]
  ) => {
    const { adjustOrder } = this.state;

    const editedPreference = updatedPreferencesData.map((updatePreference) => {
      return {
        id: updatePreference.order_items_preference_id,
        order_item_id: updatePreference.order_items_id,
        preference_id: updatePreference.selected_preference,
        upcharge_list_ids: updatePreference.selected_upcharges,
        specifications: this.getSpecificatonBodyObj(
          updatePreference.selected_specifications
        ),
      };
    });

    const updateBody = {
      id: adjustOrder?.id,
      order_item_preferences: editedPreference,
    };

    return updateBody;
  };

  handleSavePreference = (updatedPreferencesData: SelectedPreferenceData[]) => {
    this.setState({
      adjustmentSelectUpChargeModal: false,
    });

    let message = makeApiMessage({
      url: configJSON.orderItemPreferenceUpdateApiEndPoint,
      body: JSON.stringify(this.getUpdatePreferenceBody(updatedPreferencesData)),
      method: "PATCH",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  getSharedFolderInput = (orderIds?: string) => {
    let queryString = `?order_ids=${orderIds}`
    if (!orderIds) {
      const { selectedBranches, searchQuery, filters } = this.state;
      const queryForSearch = searchQuery ? `&filter_by[query]=${searchQuery}` : "";

      const orderFilter = filters.find(
        (item: IFilterItem) => item.title === "Order ID"
      )

      const customerFilter = this.state.filters.find(
        (item: IFilterItem) => item.title === "Customer"
      )

      const orderLabel = orderFilter?.value;
      const orderOptions = orderFilter?.options;
      const order = orderOptions?.find(
        (item: { label: string }) => item.label == orderLabel
      );
      const order_id = order ? order?.value : "";

      const customerLabel = customerFilter?.value;
      const customerOptions = customerFilter?.options;
      const customer_id = customerOptions?.find(
        (item: { label: string }) => item.label == customerLabel
      )?.value || "";

      const Date = this.state.filters.find(
        (item: { title: string }) => item.title === "Date"
      )?.value;

      queryString =
        `?filter_by[status_plant]=shorting_area` +
        `&store_ids=${selectedBranches.filter(isNumber).join(",")}${queryForSearch}` +
        (order_id ? `&order_ids=${order_id}` : "&order_ids=all") +
        (customer_id ? `&filter_by[customer_id]=${customer_id}` : "") +
        (Date ? `&filter_by[order_date]=${Date}` : "");
         console.log(
    "handleResendOrdershandleResendOrders",
    queryString,
  );
    }
    const message = makeApiMessage({
      method: configJSON.httpGetMethod,
      url: configJSON.metalProgettiSolutionEndPoint + queryString,
    });

    this.getSharedFolderMessageId = message.messageId
    this.send(message)
  }

  sendOrderToClean(order_id: string) {
    const body = {
      order_ids: [order_id]
    };

    let message = makeApiMessage({
      url: configJSON.orderSendToCleanEndPoint,
      body: JSON.stringify(body),
      method: "POST",
    });
    
    this.sendOrderToClanApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleSendOrderToCleanResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if(requestId == this.sendOrderToClanApiCallId) {
      if(response) {
        if(!response.errors) {
          this.setState({
            snackbarMessage: response.message,
            snackBarSeverity: 'success'
          }, () => this.onChangeTabs(this.state.selectedTab));
        } else {
          this.setState({
            snackbarMessage: response.errors,
            snackBarSeverity: 'error'
          });
        }
      }
    }
  }

  shouldShowResendButton = () => {
    const {showResendButton, selectedOption} = this.state
    if (
      !showResendButton 
      || 
      (selectedOption && selectedOption !== "metal_progetti") 
      || this.getCurrentSelectedTab().apiKey !== "shorting_area"
    ) return false
    return true
  }

  // handleResendOrders = (isAll?: boolean| string) => {
  //   const { selectedOrders } = this.state
   

  //   if (!isAll && !selectedOrders.length) return;
  //   if(!qzTray.websocket.isActive()) {
  //    this.setState({
  //     snackbarMessage : configJSON.connectionErrorMessage,
  //     snackBarSeverity: "error"
  //    })
  //     return;
  //   }
  //   this.setState({isLoadingSharedFolder: true})
  //   this.getSharedFolderInput(isAll ? undefined : selectedOrders.join(","))
  // }

    handleResendOrders = (isAll?: boolean | string) => {
    const { selectedOrders, orderData } = this.state;
    if (!isAll && !selectedOrders.length) return;

    if (!qzTray.websocket.isActive()) {
      this.setState({
        snackbarMessage: configJSON.connectionErrorMessage,
        snackBarSeverity: "error",
      });
      return;
    }
    this.setState({ isLoadingSharedFolder: true });

    let inputForSharedFolder: string | undefined;
    if (isAll === true) {
      inputForSharedFolder = undefined; 
    } else if (isAll === "garment_tag") {
      inputForSharedFolder = orderData?.attributes?.id?.toString(); 
    } else {
      inputForSharedFolder = selectedOrders.join(","); 
    }
    this.getSharedFolderInput(inputForSharedFolder);
  };

  getPaginationClasses = () => this.shouldShowResendButton() ? "my-10" : undefined

  shouldShowActionButtons = () => Boolean(this.state.selectedOption) && this.state.selectedOption !== "metal_progetti"

  shouldShowLoader = () => this.state.isScanningOrder || this.state.isLoadingSharedFolder

  isLoadingOrders = () => this.state.isPlantLoading || this.state.isOrderListLoading

  handleInputQty = (
    event: React.ChangeEvent<{ value: string }>,
    orderItem: IItemData
  ) => {
    let specials = /^\d*$/;
    if(specials.test(event.target.value)) {
      const { adjustOrderItems } = this.state;
      let tempOrderItems = JSON.parse(JSON.stringify(adjustOrderItems)) as IItemData[];
      const findChangeItem = tempOrderItems.find(
        (order_item) => order_item.id == orderItem.id
      );
      if (findChangeItem) {
        findChangeItem.attributes.quantity = Number(event.target.value);
        this.debouncedFetchSearchResults(findChangeItem);
      }

      this.setState({ adjustOrderItems: tempOrderItems });
    } else {
      alert("Please enter number only");
    }
  };

  handleCustomChangeQty = (findChangeItem: IItemData) => {
    const { adjustOrder, isB2bMode } = this.state;
    
    const customer_Id = sortCondition(
      isB2bMode,
      { business_account_customer_id: adjustOrder?.customer.id },
      { customer_id: adjustOrder?.customer.id }
    ) as {[key in string]: string | number}

    const putBody = {
      data: {
        ...customer_Id,
        store_management_id: adjustOrder?.store_management_id,
        order_items_attributes: [
          {
            id: findChangeItem.id,
            quantity: findChangeItem.attributes.quantity,
            _destroy: findChangeItem.attributes.quantity == 0 ? true : false,
          },
        ],
      },
    };

    let message = makeApiMessage({
      url: conditionalString(
        isB2bMode,
        configJSON.b2bOrderUpdateEndPoint, 
        configJSON.getOrderByIdEndpoint
      ) + adjustOrder?.id,
      body: JSON.stringify(putBody),
      method: "PUT",
    });
    this.updateOrderApiCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  debouncedFetchSearchResults = debounce(this.handleCustomChangeQty, 500);

  returnDetailsTableRowNotes = (notes: string) => {
    if(notes) {
      return notes;
    } else {
      return "---";
    }
  };

  getSectionList = () => {
    const message = makeApiMessage({
      method: "GET",
      url: configJSON.gerSectionListEndPoint + `&allow_access=true`,
    });

    this.getSectionListId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleSectionListAPIResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if(requestId == this.getSectionListId) {
      if(response) {
        this.setState({ sectionList: response.data });
        const existingFilter = this.state.filters.find(
          (item) => item.title === "Section"
        );
        if (!existingFilter) return;
        existingFilter.options = response.data.map((item: SectionItem) => {
          return {
            value: item.id,
            label: item.attributes.section_name,
          };
        });
        this.setState({ filters: [...this.state.filters] });
      }
    }
  };

  renderNotesInDetails = (notes: string | undefined) => notes !== null && notes !== "";

  renderCustomerComplaint = (customer_complaint: string | undefined) => 
    customer_complaint !== null && customer_complaint !== "";

  renderCreditOrderNumber = (order_number: string | undefined) => {
    const { hidden, creditNoteOrderNumber, openCrediNoteModalLoader } = this.state;
    if(openCrediNoteModalLoader) {
      return "";
    } else {
      if(!hidden) {
        return order_number;
      } else {
        return creditNoteOrderNumber;
      }
    }
  };

  toggleAutoSendMode = async () => {
    if (this.disableToggleAutoSend) return;
    this.disableToggleAutoSend = true
    const { isAutoSend } = this.state
    const updateState : Partial<S> = {}
    if (!isAutoSend) {
      try {
        if (!qzTray.websocket.isActive()) {
          await qzTray.websocket.connect()
        }
        this.disableGetFiles = false
        this.getFilesForAutoSend()
        this.autoSendFiles = setInterval(() => this.getFilesForAutoSend(), 60000)
        updateState.isAutoSend = true
      }catch(error) {
        updateState.snackbarMessage = configJSON.connectionErrorMessage
        updateState.snackBarSeverity = "error"
      }
    } else {
      clearInterval(this.autoSendFiles)
      updateState.isAutoSend = false
    }
    this.setState(updateState as Pick<S, keyof S>, () => this.disableToggleAutoSend = false)
  }

  turnOnAutoSendMode = async () => {
    if (this.state.isAutoSend) return; // Already on
    if (this.disableToggleAutoSend) return;
    this.disableToggleAutoSend = true
    const updateState : Partial<S> = {}
    try {
      if (!qzTray.websocket.isActive()) {
        await qzTray.websocket.connect()
      }
      this.disableGetFiles = false
      this.getFilesForAutoSend()
      this.autoSendFiles = setInterval(() => this.getFilesForAutoSend(), 60000)
      updateState.isAutoSend = true
    } catch(error) {
      updateState.snackbarMessage = configJSON.connectionErrorMessage
      updateState.snackBarSeverity = "error"
    }
    this.setState(updateState as Pick<S, keyof S>, () => this.disableToggleAutoSend = false)
  }

  turnOffAutoSendMode = () => {
    if (!this.state.isAutoSend) return; // Already off
    clearInterval(this.autoSendFiles)
    this.setState({ isAutoSend: false })
  }

  getFilesForAutoSend = () => {
    if (this.disableGetFiles) return;
    this.disableGetFiles = true;
    const apiMessage = makeApiMessage({
      method: "GET",
      url: configJSON.metalProgettiSolutionEndPoint + "?is_automatic=true"
    })
    this.getFilesForAutoSendMessageId = apiMessage.messageId
    this.send(apiMessage)
  }

  writeFile = async (filePath: string, fileContent: string) => {
    try {
      await qzTray.file.write(filePath, { sandbox: false, shared: true, data: fileContent})
      const fileName = filePath.substring(filePath.lastIndexOf('\\') + 1)
      return fileName
    } catch (error) {
      runEngine.debugLog("Error writing file " + filePath)
      console.error(error)
      return ""
    }
  }

  writeFiles = async (payload: { file_path: string, file_content: string }[], isAutoSend = false ,is_more = false) => {
    try {
      if (!qzTray.websocket.isActive()) {
        await qzTray.websocket.connect()
      }

      // Extract unique shared folders and create verification folder paths
      const sharedFolders = new Set<string>()
      payload.forEach(fileItem => {
        const lastBackslash = fileItem.file_path.lastIndexOf('\\')
        if (lastBackslash !== -1) {
          sharedFolders.add(fileItem.file_path.substring(0, lastBackslash))
        }
      })

      // Create verification folders (if not exist), clear existing files, and store paths
      this.verificationFolderPaths.clear()
      for (const folder of sharedFolders) {
        const verificationPath = folder + "\\verification"
        this.verificationFolderPaths.add(verificationPath)
        await this.ensureVerificationFolderExists(verificationPath)
        await this.clearVerificationFolder(verificationPath)
      }

      // Write files to both original path and verification folder
      const writePromises = payload.flatMap(fileItem => {
        const lastBackslash = fileItem.file_path.lastIndexOf('\\')
        const fileName = fileItem.file_path.substring(lastBackslash + 1)
        const sharedFolder = fileItem.file_path.substring(0, lastBackslash)
        const verificationPath = sharedFolder + "\\verification\\" + fileName
        return [
          this.writeFile(fileItem.file_path, fileItem.file_content),
          this.writeFile(verificationPath, fileItem.file_content)
        ]
      })

      const writtenFilePaths = await Promise.all(writePromises)
      // Filter only original file writes (every other result starting from index 0)
      const originalFileResults = writtenFilePaths.filter((_, index) => index % 2 === 0)
      const successfulFiles = originalFileResults.filter(Boolean)

      this.setState({
        snackbarMessage: `${successfulFiles.length} files have been written to shared folders`,
        snackBarSeverity: successfulFiles.length ? "success": "error"
      })
      if (successfulFiles.length) {
        this.isMoreFilesToSend = is_more
        const setKey = isAutoSend ? "filesWrittenByAutosend" : "filesWrittenByResend"
        successfulFiles.forEach(fileName => this[setKey].add(fileName))
        this.updateInFiles(isAutoSend)
      }
    } catch (error) {
      console.error(error)
      this.disableGetFiles = false
      this.setState({snackbarMessage: configJSON.connectionErrorMessage, snackBarSeverity: "error", isAutoSend: false})
    }
  }

  ensureVerificationFolderExists = async (verificationPath: string) => {
    try {
      await qzTray.file.list(verificationPath, { sandbox: false, shared: true })
    } catch (error) {
      try {
        const tempFilePath = verificationPath + "\\.folder_init"
        await qzTray.file.write(tempFilePath, { sandbox: false, shared: true, data: " " })
        await qzTray.file.remove(tempFilePath, { sandbox: false, shared: true })
      } catch (createError) {
        console.log("Could not create verification folder:", verificationPath)
      }
    }
  }

  clearVerificationFolder = async (verificationPath: string) => {
    try {
      const files = await qzTray.file.list(verificationPath, { sandbox: false, shared: true })
      if (files && files.length) {
        await Promise.all(files.map((file: string) =>
          qzTray.file.remove(verificationPath + "\\" + file, { sandbox: false, shared: true })
        ))
      }
    } catch (error) {
      // Folder might not exist yet, which is fine
    }
  }

  updateInFiles = (isAutoSend: boolean) => {
    const in_file_names = Array.from(isAutoSend ? this.filesWrittenByAutosend : this.filesWrittenByResend)
    const callId = isAutoSend ? "updateInFilesAfterAutoSendCallId" : "updateInFilesAfterResendCallId"
    const apiMessage = makeApiMessage({
      url: configJSON.updateOutFileApi,
      method: "POST",
      body: JSON.stringify({
        in_file_names
      })
    })
    this[callId] = apiMessage.messageId
    this.send(apiMessage)
  }

  handleUpdateInFilesResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    if (![this.updateInFilesAfterAutoSendCallId, this.updateInFilesAfterResendCallId].includes(requestId)) return;
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId === this.updateInFilesAfterAutoSendCallId) {
      this.disableGetFiles = false
      if (responseJson.errors === "No file data uploaded") {
        this.filesWrittenByAutosend.clear()
        if (this.isMoreFilesToSend && this.state.isAutoSend) {
          this.getFilesForAutoSend()
        }
      }
    }
    if (requestId === this.updateInFilesAfterResendCallId) {
      if (responseJson.errors === "No file data uploaded") {
        this.filesWrittenByResend.clear()
      }
    }
    // After update_out_files API is called, verify files from verification folder
    this.verifyInFilesFromVerificationFolder()
  }

  verifyInFilesFromVerificationFolder = async () => {
    try {
      if (!qzTray.websocket.isActive()) {
        await qzTray.websocket.connect()
      }
      const allFileNames: string[] = []
      for (const verificationPath of this.verificationFolderPaths) {
        try {
          const files = await qzTray.file.list(verificationPath, { sandbox: false, shared: true })
          if (files && files.length) {
            allFileNames.push(...files)
          }
        } catch (error) {
          console.log("Error reading verification folder:", verificationPath)
        }
      }
      if (allFileNames.length) {
        this.callVerifyInFilesApi(allFileNames)
      }
    } catch (error) {
      console.error("Error verifying in files:", error)
    }
  }

  callVerifyInFilesApi = (fileNames: string[]) => {
    const apiMessage = makeApiMessage({
      url: configJSON.verifyInFilesApi,
      method: "POST",
      body: JSON.stringify({
        verified_files: fileNames
      })
    })
    this.verifyInFilesCallId = apiMessage.messageId
    this.send(apiMessage)
  }

  handleVerifyInFilesResponse = (message: Message) => {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    if (requestId !== this.verifyInFilesCallId) return;
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (responseJson?.verified_count) {
      console.log(`Verified ${responseJson.verified_count} files:`, responseJson.verified_file_names)
    }
  }

  getToggleButtonClass = () => this.state.isAutoSend ? undefined : "off-btn"

  moveToNextButtonClasses = () => "add mw-186" + (!this.isShowNextLabel() ? " disable-btn" : "")

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

  handleSetStateFilter = (filters: IFilterItem[]) => {
    this.setState({ filters })
  };

  deleteDummyAdjustOrder(orderId: string) {
    let message = makeApiMessage({
      url: configJSON.deleteOrderByIdEndpoint + orderId,
      method: "DELETE",
    });
    this.deleteAdjustmentOrderMessageId = message.messageId;
    this.send(message);
  }

  golden_point_backup_order(orderId: string) {
    const message = makeApiMessage({
      url: `${configJSON.goldenPointBackupOrder}${orderId}/golden_point_backup_order`,
      method: "PUT",
    });

    this.goldenPointBackupOrder = message.messageId;
    this.send(message);
  }

  moveToShortingAreaByScanning = (orderToMove: IDataItem, nextOrder: IDataItem) => {
    const body = JSON.stringify({
      status: "shorting_area",
      order_ids: [orderToMove.attributes.id],
    });

    this.setState({isUpdateStatusLoading:true})
    const message = makeApiMessage({
      url: configJSON.plantOrderUpdateEndPoint,
      method: "PATCH",
      body: body,
    });

    this.autoMoveToShortingAreaData = {
      apiCallId: message.messageId,
      nextOrder
    }
    this.send(message)
  }

  handleAutoMoveToShortingAreaResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (requestId !== toString(this.autoMoveToShortingAreaData?.apiCallId)) return;
    if (response.status === 200) {
      this.getOrderList(this.getCurrentSelectedTab().apiKey)
    }
    this.setState((prev) => ({
      isUpdateStatusLoading: false,
      snackbarMessage: sortStringCondition(
        response.status !== 200,
        "Cannot move current order to shorting area",
        prev.snackbarMessage
      ),
      snackBarSeverity: sortStringCondition(
        response.status !== 200,
        "error",
        prev.snackBarSeverity
      ) as "success" | "error"
    }) , () => {
      this.autoMoveToShortingAreaData?.nextOrder && this.onOpenOrderDetails(this.autoMoveToShortingAreaData.nextOrder)
      this.autoMoveToShortingAreaData = null
    })
  }

  formatValue(value: NullableString): string {
    if (value === "0.00") {
      return "---";
    } else {
      return value || "---";
    }
  }

  formatValueFiled(value: NullableString): string {
    return value || "---";
  }
  
  formatBusinessName(value: NullableString): string {
    return value?.trim() || "---";
  }

  formatkey(value: string | undefined) {
    return value
  }


  handleClickMapTag() {
    const { orderItems, isEditTagMode } = this.state;

    // Toggle off if already in edit mode
    if (isEditTagMode) {
      this.setState({
        isEditTagMode: false,
        currentMapTagIndex: 0,
      });
      return;
    }

    const editableTagValues: { [key: string]: string } = {};
    orderItems.forEach((item, index) => {
      const permanentTagCode = item.attributes.order_item_tags?.[0]?.permanent_tag?.tag_code || "";
      editableTagValues[`${item.id}${index}`] = permanentTagCode;
    });

    // Find the first unmapped item (item without permanent_tag)
    const firstUnmappedIndex = orderItems.findIndex(
      item => !item.attributes.order_item_tags?.[0]?.permanent_tag?.tag_code
    );

    const targetIndex = firstUnmappedIndex >= 0 ? firstUnmappedIndex : orderItems.length;

    this.setState({
      isEditTagMode: true,
      editableTagValues,
      currentMapTagIndex: targetIndex,
    }, () => {
      // Scroll to the first unmapped item when entering map tag mode
      this.scrollToOrderItem(targetIndex);
    });
  }

  handleTagInputChange = (id: string, value: string) => {
    this.setState((prevState) => ({
      editableTagValues: {
        ...prevState.editableTagValues,
        [id]: value,
      },
    }));
  };

  handleConditon = (condition: any, truePart: any, falsePart: any) => {
    return condition ? truePart: falsePart
  }

      getRawInvoiceData = (orderId: string) => {
        console.log("1234567890")
      if (this.savedRawPrintDatasMap.has(orderId)) {
        const payload = this.savedRawPrintDatasMap.get(orderId);
        payload && this.handleRawPrint(payload);
        return;
      }

      const apiUrl =
        `${configJSON.rawOrderInvoiceData}${orderId}&plantReceipt=true`;

      const apiMessage = makeApiMessage({
        url: apiUrl,
        method: "GET"
      });

      this.getRawOrderInvoiceDataCallId = apiMessage.messageId;

      this.send(apiMessage);
    };

      handleRawPrint = (payload: InvoiceRawData) => {
        const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
        printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_RECEIPT")
        printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), payload)
        this.send(printMessage)
        this.closePrinterDialog()
      }

       openPrinterDialog = (orderItem: InvoicesRawData) => {
          this.setState({ orderToPrint: orderItem })
        }
        closePrinterDialog = () => {
          this.setState({ orderToPrint: null })
        }

    handleGetRawInvoiceResponse = (message: Message) => {
      const requestId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      if (requestId !== this.getRawOrderInvoiceDataCallId) return;

      const response = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const error = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      let errorMessage = "";

      if (error) {
        errorMessage =
          error?.errors || error?.message || "Unable to fetch invoice data";
      }

      else if (!response?.data) {
        errorMessage = "No invoice data available for printing";
      }

      else {
        const invoiceData = response.data as InvoicesRawData;

        if (this.savedRawPrintDatasMap.size > 50) {
          const firstInsertedKey = this.savedRawPrintDatasMap.keys().next().value;
          this.savedRawPrintDatasMap.delete(firstInsertedKey as string);
        }

        // if (invoiceData.order?.order_id) {
        //   this.savedRawPrintDatasMap.set(
        //     String(invoiceData.order.order_id),
        //     invoiceData
        //   );
        // }
        if (invoiceData.order?.order_id) {
          this.savedRawPrintDatasMap.set(
            String(invoiceData.order.order_id),
            invoiceData as unknown as InvoiceRawData
          );
        }
       this.handleRawPrint(invoiceData as unknown as InvoiceRawData);
        // this.handleRawPrint(invoiceData);
      }

      this.setState((prev) => ({
        // isLoadingRawInvoice: false,
        snackbarMessage: errorMessage,
        snackBarSeverity: errorMessage ? "error" : prev.snackBarSeverity
      }));
    };

  // Customizable Area End
}
